export default {
  "account-candidate-content": "Hãy tham gia các bài đánh giá kỹ năng và\nchứng minh năng lực kỹ thuật của bạn.",
  "account-organization-title": "Tổ chức",
  "account-organization-content": "Đánh giá năng lực kỹ thuật của ứng viên và\nđưa ra quyết định dựa trên dữ liệu.",
  "sign-up-top-title": "Tạo tài khoản Codepresso",
  "account-login": "Đăng nhập",
  "account-signup": "Đăng ký",
  "account-email": "Email",
  "account-password": "Mật khẩu",
  "social-title": "Hoặc",
  "social-linkedin": "LinkedIn",
  "social-google": "Google",
  "sign-up-term-content": "Thông qua việc Đăng ký, bạn đồng ý với {policy} và {term} của chúng tôi và xác nhận bạn đủ 16 tuổi.",
  "common-terms-of-use": "Điều Khoản Sử Dụng",
  "common-legal-notice": "Thông báo Pháp lý",
  "common-privacy-policy": "Chính sách Bảo mật",
  "common-cookie-policy": "Chính Sách Cookie",
  "sign-up-bottom": "Bạn đã có tài khoản rồi?",
  "error-null-email": "Bạn phải nhập địa chỉ email.",
  "error-personal-email": "Email cá nhân hoặc email tạm thời không được chấp nhận.\nVui lòng nhập email doanh nghiệp của bạn.",
  "error-signup-blocked": "Bạn không thể đăng ký bằng email này.\nVui lòng thử lại, và nếu vấn đề vẫn tiếp diễn, hãy liên hệ với support@codepresso.io để được hỗ trợ.",
  "error-null-password": "Bạn phải nhập mật khẩu có ít nhất 10 ký tự.",
  "error-sign-wrong-approach": "Yêu cầu của bạn không thực hiện được do lỗi. \nVui lòng thử lại.",
  "error-invalid-email": "Đảm bảo rằng bạn nhập đúng địa chỉ email.",
  "error-invalid-password-size": "Mật khẩu của bạn phải chứa ít nhất 10 ký tự.",
  "error-invalid-password": "Mật khẩu của bạn phải chứa cả số, chữ viết hoa và chữ viết thường.",
  "sign-send-verification-email": "Chúng tôi đã gửi email xác minh.",
  "sign-verify-email-title": "Xác minh email\ncủa bạn để bắt đầu khám phá Codepresso",
  "sign-verify-email-content": "Kiểm tra email mà chúng tôi đã gửi đến địa chỉ email '{email}' và làm theo hướng dẫn. Nếu bạn chưa nhận được email xác minh, hãy nhấp vào nút bên dưới để được gửi lại.",
  "sign-verify-email-resend": "Gửi lại Email Xác minh",
  "sign-resend-verification-email": "Chúng tôi đã gửi lại email xác minh.",
  "sign-send-verification-email-delay": "Vui lòng đợi 30 giây trước khi cố gắng yêu cầu gửi lại email xác minh.",
  "sign-up-complete-title": "Bạn đã sẵn sàng để bắt đầu",
  "sign-up-complete-content": "Việc xác minh email cho tài khoản '{email}' đã hoàn tất và bạn có thể bắt đầu sử dụng Codepresso ngay bây giờ.",
  "common-start": "Bắt đầu",
  "sign-up-fail-title": "Vui lòng gửi lại email xác minh",
  "sign-up-fail-description": "Chúng tôi không thể xác minh email do liên kết đã hết hạn.",
  "sign-up-error-title": "Do lỗi kỹ thuật nên chúng tôi không thể xác minh địa chỉ email của bạn",
  "sign-up-error-content": "Vui lòng nhấn vào nút trong email và thử lại.",
  "sign-in-top-title": "Đăng nhập vào tài khoản",
  "sign-in-bottom": "Bạn chưa có tài khoản?",
  "account-find-password": "Quên mật khẩu",
  "error-account-mis-match": "Kiểm tra lại địa chỉ email và mật khẩu của bạn.",
  "skillCertify-session-expired-title": "Phiên đăng nhập đã hết hạn nên không thể nộp câu trả lời.",
  "skillCertify-session-expired-description": "Câu trả lời của bạn đã được lưu an toàn. Vui lòng đăng nhập lại để tiếp tục làm bài.",
  "skillCertify-session-expired-save-fail": "Không thể lưu câu trả lời nên chưa chuyển đến trang đăng nhập. Vui lòng thử lại sau giây lát.",
  "error-used-email": "Địa chỉ email này đã được sử dụng.",
  "account-required": "Yêu cầu đăng nhập.",
  "account-up-required": "Yêu cầu đăng ký.",
  "password-change-enter-email": "Nhập địa chỉ email của bạn",
  "password-change-send-mail-content": "Bạn sẽ nhận một email giúp bạn cài đặt lại mật khẩu.",
  "password-change-send-mail": "Gửi Email",
  "password-change-send-success-dot": "Chúng tôi đã gửi cho bạn email để cài đặt lại mật khẩu.",
  "password-change-send-success": "Chúng tôi đã gửi cho bạn email để cài đặt lại mật khẩu",
  "password-change-resend-mail-content-1": "Kiểm tra email mà chúng tôi đã gửi đến địa chỉ email '{email}' và làm theo hướng dẫn. ",
  "password-change-resend-mail-content-2": "Nếu bạn chưa nhận được email xác minh, hãy nhấp vào nút bên dưới để được gửi lại.",
  "password-change-resend-email": "Gửi lại Email Cài đặt lại Mật khẩu",
  "password-change-resend-success": "Chúng tôi đã gửi lại cho bạn email để cài đặt lại mật khẩu.",
  "password-change-resend-delay": "Vui lòng đợi 30 giây trước khi cố gắng yêu cầu gửi lại email cài đặt lại mật khẩu.",
  "password-change-title": "Cài đặt mật khẩu mới",
  "password-change-content": "Vui lòng nhập mật khẩu mới cho '{email}' vào ô bên dưới.",
  "password-change-new-password": "Mật khẩu mới",
  "password-change-confirm-new-password": "Xác nhận mật khẩu mới",
  "password-change": "Thay đổi mật khẩu",
  "error-null-new-password": "Bạn phải nhập mật khẩu mới.",
  "error-null-confirm-new-password": "Đảm bảo rằng mật khẩu mới và xác nhận mật khẩu mới giống nhau.",
  "error-save-new-password": "Đã xảy ra lỗi nên không thể lưu mật khẩu mới của bạn.",
  "password-change-success": "Bạn đã thay đổi mật khẩu",
  "password-change-continue": "Mật khẩu của tài khoản '{email}' đã được thay đổi.\nĐăng nhập vào tài khoản Codepresso của bạn để tiếp tục.",
  "password-change-login-account": "Đăng nhập vào tài khoản của tôi",
  "password-change-fail": "Vui lòng gửi lại email cài đặt lại mật khẩu",
  "password-change-fail-description": "Không thể tiến hành đặt lại mật khẩu do liên kết đã hết hạn.",
  "register-description": "Xin chào, {nickName}!\nVui lòng hoàn tất đăng ký tài khoản của bạn",
  "register-country-select": "Vui lòng chọn quốc gia/khu vực.",
  "register-country-region": "Tìm kiếm quốc gia/khu vực",
  "common-none-search-data": "Không tìm thấy kết quả.",
  "common-next": "Tiếp theo",
  "register-notifications-main-content": "Bạn có muốn nhận email cập nhật về những nội dung mới nhất về các sự kiện, tin tức, các tính năng mới, các cuộc thi và nhiều thông tin hữu ích khác từ Codepresso không?",
  "register-notifications-sub-content-1": "Tôi muốn nhận các cập nhật từ Codepresso qua email.",
  "common-first-name": "Tên",
  "common-placeholder-first-name": "Điền tên của bạn.",
  "error-first-name": "Tên của bạn phải chứa từ 1 đến 25 ký tự.",
  "error-invalid-first-name": "Đảm bảo rằng bạn nhập đúng tên.",
  "common-last-name": "Họ",
  "common-placeholder-last-name": "Điền họ của bạn.",
  "error-last-name": "Họ của bạn phải chứa từ 1 đến 25 ký tự.",
  "error-invalid-last-name": "Đảm bảo rằng bạn nhập đúng họ.",
  "organization-create-title": "Tiếp theo, hãy lựa chọn việc tạo tổ chức",
  "organization-create-option-1": "Tạo tổ chức",
  "organization-create-option-2": "Không tạo tổ chức",
  "organization-create-description": "Nếu bạn tạo tổ chức, {username} sẽ được cấp vai trò Quản trị viên chính của tổ chức và có thể bắt đầu quản lý tổ chức.",
  "common-organization-name": "Tên tổ chức",
  "common-placeholder-organization-name": "Vui lòng nhập tên tổ chức của bạn.",
  "error-organization-name": "Tên tổ chức phải có từ 1 đến 50 ký tự.",
  "register-organization-size-title": "Quy mô tổ chức",
  "register-organization-size-select": "Vui lòng chọn quy mô tổ chức của bạn.",
  "settings-title": "Cài đặt",
  "settings-logout": "Đăng xuất",
  "account-username": "Tên người dùng",
  "account-organization": "Tổ chức",
  "account-none-organization": "Bạn không thuộc về tổ chức nào",
  "account-country": "Quốc gia/Khu vực",
  "common-save": "Lưu",
  "account-change-success": "Thay đổi tài khoạn của bạn đã được lưu.",
  "account-change-fail": "Chúng tôi không thể lưu thay đổi tài khoản của bạn.\nVui lòng thử lại.",
  "account-valid-name-size": "Tên người dùng phải từ 2 đến 25 ký tự.",
  "settings-account": "Tài khoản",
  "settings-notifications": "Thông báo",
  "account-delete": "Xóa tài khoản",
  "account-my-delete": "Xóa Tài khoản của tôi",
  "account-delete-agree-title": "Vui lòng đồng ý trước khi xóa tài khoản",
  "account-delete-agree-description": "Thông tin nhận dạng cá nhân sẽ bị xóa vĩnh viễn, và một số thông tin ẩn danh có thể được lưu lại cho mục đích thống kê.\nĐể biết thêm chi tiết, vui lòng tham khảo {linkDom}.",
  "account-delete-agree-info": "Tôi đồng ý rằng thông tin nhận dạng cá nhân của tôi sẽ bị xóa vĩnh viễn, và một số thông tin đã được ẩn danh có thể được lưu lại cho mục đích thống kê.",
  "account-delete-success": "Đã xóa tài khoản của bạn.",
  "account-delete-fail": "Chúng tôi không thể xóa tài khoản của bạn.\nVui lòng thử lại.",
  "account-current-password": "Mật khẩu Hiện tại",
  "error-current-password": "Bạn phải nhập mật khẩu hiện tại.",
  "error-password-incorrect": "Đảm bảo rằng mật khẩu hiện tại là đúng.",
  "password-saving-success": "Đã lưu thay đổi mật khẩu của bạn.",
  "password-saving-fail": "Chúng tôi không thể lưu thay đổi mật khẩu của bạn.\nVui lòng thử lại.",
  "notifications-agree-title": "Nhận tin tức từ Codepresso",
  "notifications-agree-content": "Cập nhật những nội dung mới nhất về các sự kiện, tin tức, các tính năng mới, các cuộc thi và nhiều thông tin hữu ích khác từ Codepresso.",
  "notifications-change-success": "Các tuỳ chọn thông báo của bạn đã được lưu.",
  "notifications-change-fail": "Chúng tôi không thể lưu các tuỳ chọn thông báo của bạn.\nVui lòng thử lại.",
  "organization-members-management": "Quản lý người dùng trong tổ chức",
  "account-delete-transfer-of-role-info": "Trước khi xóa tài khoản, vui lòng chuyển quyền quản trị viên chính của tổ chức cho một người dùng khác trong tổ chức.",
  "account-delete-info": "Bạn có thể xóa tài khoản sau khi gói đăng ký kết thúc.",
  "organization-settings-title": "Cài đặt tổ chức",
  "organization-create-button": "Tạo",
  "organization-create-success": "Tổ chức đã được tạo thành công.",
  "organization-create-fail": "Chúng tôi không thể tạo tổ chức này.\nVui lòng thử lại.",
  "organization-leave": "Rời khỏi tổ chức",
  "organization-my-leave": "Rời khỏi tổ chức của tôi",
  "organization-leave-transfer-of-role-info": "Trước khi rời khỏi tổ chức, vui lòng chuyển quyền quản trị viên chính của tổ chức cho một người dùng khác trong tổ chức.",
  "organization-leave-info": "Bạn có thể rời khỏi tổ chức sau khi gói đăng ký kết thúc.",
  "organization-leave-title": "Bạn có chắc chắn muốn rời khỏi tổ chức này không?",
  "organization-leave-info-1": "Bạn không thể sử dụng các tính năng liên quan đến tổ chức {OrganizationName} nữa.",
  "organization-leave-info-2-prefix": "Khi bạn nhập ",
  "organization-leave-info-2-suffix": ", nút [Rời khỏi] sẽ được kích hoạt.",
  "organization-leave-button": "Rời khỏi",
  "organization-leave-success": "Việc rời khỏi tổ chức đã được hoàn tất thành công.",
  "organization-leave-fail": "Chúng tôi không thể hoàn tất việc rời khỏi tổ chức.\nVui lòng thử lại.",
  "organization-change-success": "Đã lưu các thay đổi của tổ chức.",
  "organization-change-fail": "Chúng tôi không thể lưu các thay đổi của tổ chức.\nVui lòng thử lại.",
  "organization-Invite-members": "Mời người dùng",
  "organization-Invite-members-description": "Thư mời sẽ được gửi tới địa chỉ email bạn đã nhập.",
  "organization-menu-access": "Quyền truy cập menu",
  "organization-role": "Vai trò",
  "organization-role-select": "Vui lòng chọn vai trò.",
  "organization-role-administrator": "Quản trị viên",
  "organization-role-administrator-description": "Cho phép truy cập các tính năng trong menu và xem thông tin của tổ chức.",
  "organization-member-remove-title": "Bạn có chắc chắn muốn xóa người dùng này không?",
  "organization-member-remove-success": "Người dùng đã được xóa thành công.",
  "organization-member-add": "Thêm người dùng",
  "organization-member-add-success": "Người dùng đã được thêm thành công.",
  "organization-Invite-members-success": "Lời mời tham gia đã được gửi tới {Count} người dùng.",
  "organization-Invite-members-fail": "Chúng tôi không thể mời {Count} người dùng.\nVui lòng thử lại.",
  "organization-Invite-members-email-error-1": "Địa chỉ email này đã thuộc về một tổ chức.",
  "organization-Invite-members-email-error-2": "Địa chỉ email này đã được mời.",
  "organization-Invite-members-email-error-3": "Địa chỉ email này đã bị trùng lặp.",
  "organization-Invite-members-menu-access-error": "Bạn phải chọn ít nhất một menu.",
  "organization-member-count": "Người dùng",
  "organization-member": "Người dùng",
  "organization-role-chief-administrator": "Quản trị viên chính",
  "organization-invited": "Đã mời",
  "organization-active": "Đang hoạt động",
  "organization-last-accessed-date": "Ngày truy cập gần đây",
  "organization-transfer-of-role-button-1": "Chuyển quyền quản trị viên chính của tổ chức",
  "organization-member-edit": "Chỉnh sửa người dùng",
  "organization-member-delete": "Xóa người dùng",
  "organization-member-resend-email-description": "Bạn có muốn gửi lại lời mời tham gia tới '{email}'?",
  "organization-member-resend-email-success": "Chúng tôi đã gửi lại lời mời tham gia tới '{email}'.",
  "organization-member-resend-email-fail": "Chúng tôi không thể gửi lại lời mời tham gia tới '{email}'.\nVui lòng thử lại.",
  "organization-transfer-of-role-title": "Vui lòng đồng ý trước khi chuyển quyền quản trị viên chính của tổ chức",
  "organization-transfer-of-role-description": "Sau khi chuyển quyền, bạn sẽ trở thành quản trị viên của tổ chức và không thể chỉnh sửa thông tin tổ chức nữa.",
  "organization-transfer-of-role-info": "Tôi đồng ý với việc chuyển quyền quản trị viên chính của tổ chức.",
  "organization-transfer-of-role-button-2": "Chuyển quyền",
  "organization-transfer-of-role-success": "Quyền quản trị viên chính của tổ chức đã được chuyển.",
  "organization-transfer-of-role-fail": "Chúng tôi không thể chuyển quyền quản trị viên chính của tổ chức.\nVui lòng thử lại.",
  "organization-member-information": "Thông tin người dùng",
  "organization-member-information-success": "Thông tin người dùng đã được lưu.",
  "organization-member-information-fail": "Chúng tôi không thể lưu thông tin người dùng.\nVui lòng thử lại.",
  "organization-member-delete-title": "Bạn có chắc chắn muốn xóa người dùng này không?",
  "organization-member-delete-success": "Người dùng đã được xóa thành công.",
  "organization-member-delete-fail": "Chúng tôi không thể xóa người dùng này.\nVui lòng thử lại.",
  "organization-invite-accept-fail": "Chúng tôi không thể xử lý yêu cầu tham gia tổ chức\n{OrganizationName}",
  "organization-invite-accept-fail-content": "Không thể chấp nhận lời mời vì địa chỉ email này thuộc về một tổ chức khác hoặc đã xảy ra lỗi.\nVui lòng rời khỏi tổ chức hiện tại và thử lại, hoặc yêu cầu quản trị viên gửi lời mời mới.",
  "organization-invite-accept-success": "Bạn đã tham gia tổ chức\n{OrganizationName}",
  "organization-invite-accept-success-content": "Từ bây giờ, bạn có thể sử dụng các tính năng liên quan đến tổ chức {OrganizationName}.",
  "organization-Invite-members-restriction-info": "Tính năng Mời người dùng khả dụng trên các gói Pro và Enterprise.",
  "organization-subscription-management": "Quản lý đăng ký",
  "organization-subscription-none-description-1": "Chưa có gói đăng ký nào đang hoạt động.",
  "organization-subscription-none-description-2": "Vui lòng tiến hành đăng ký, để sử dụng dịch vụ.",
  "organization-subscription-none-button": "Xem các gói",
  "organization-subscription-label-1": "Đã đăng ký",
  "organization-subscription-label-2": "Cần thanh toán",
  "organization-subscription-label-3": "Đang chờ hủy đăng ký",
  "organization-subscription-label-4": "Gói đăng ký đã kết thúc",
  "organization-subscription-manage": "Quản lý",
  "organization-subscription-change-payment-method": "Thay đổi phương thức thanh toán",
  "organization-subscription-coupon-management": "Quản lý mã giảm giá",
  "organization-subscription-applied": "Đã áp dụng",
  "organization-subscription-cancel-apply": "Hủy áp dụng",
  "organization-subscription-cancel-subscription": "Hủy đăng ký",
  "organization-subscription-change-billing-cycle-button": "Thay đổi",
  "organization-subscription-change-payment-method-success": "Đã thay đổi phương thức thanh toán.",
  "organization-subscription-cancel-subscription-title": "Bạn có muốn hủy đăng ký không?",
  "organization-subscription-cancel-subscription-description-1": "Sau khi hủy đăng ký, bạn vẫn có thể sử dụng dịch vụ đến {date}.",
  "organization-subscription-cancel-subscription-description-3": "Việc tạo đánh giá mới và mời ứng viên bị hạn chế.",
  "organization-subscription-cancel-subscription-description-4": "Các bài đánh giá và dữ liệu hiện có sẽ được giữ lại.",
  "organization-subscription-cancel-subscription-success": "Đã hủy đăng ký.",
  "organization-subscription-cancel-subscription-fail": "Không thể hoàn tất việc hủy đăng ký.\nVui lòng thử lại.",
  "organization-subscription-payment-failed": "Thanh toán thất bại",
  "organization-subscription-payment-failed-description-1": "Dịch vụ của bạn sẽ bị hạn chế nếu thanh toán không được hoàn tất trước {date}.",
  "organization-subscription-payment-failed-description-2": "Đang thử lại thanh toán tự động",
  "organization-subscription-retry-payment": "Thử thanh toán lại",
  "organization-subscription-retry-payment-title": "Bạn có muốn thử thanh toán lại không?",
  "organization-subscription-retry-payment-description": "Thanh toán sẽ được thực hiện ngay bằng phương thức đã đăng ký.",
  "organization-subscription-retry-payment-success": "Thanh toán đã hoàn tất.",
  "organization-subscription-retry-payment-fail": "Không thể hoàn tất thanh toán.\nVui lòng thử lại.",
  "payment-complete-next-billing-attempt-date": "Ngày thử thanh toán tiếp theo",
  "organization-subscription-cancellation-pending-description": "Bạn có thể sử dụng dịch vụ đến {date}.\nSau đó, dịch vụ sẽ tự động kết thúc và bạn sẽ không bị tính phí.",
  "organization-subscription-cancel-cancellation-request": "Hủy yêu cầu hủy đăng ký",
  "organization-subscription-cancel-cancellation-request-success": "Yêu cầu hủy đăng ký đã được hủy bỏ.",
  "organization-subscription-cancel-cancellation-request-fail": "Không thể hủy yêu cầu này.\nVui lòng thử lại.",
  "organization-subscription-restart-subscription": "Đăng ký lại",
  "organization-subscription-restart-subscription-title": "Bạn có muốn đăng ký lại không?",
  "organization-subscription-restart-subscription-description-1": "Gói để đăng ký lại",
  "organization-subscription-restart-subscription-description-2": "Khi bạn đăng ký lại, tài khoản của bạn sẽ bị tính phí và bạn có thể sử dụng lại dịch vụ.",
  "organization-subscription-restart-subscription-success": "Đã đăng ký lại.",
  "organization-subscription-restart-subscription-fail": "Không thể đăng ký lại.\nVui lòng thử lại.",
  "organization-subscription-end-subscription-description": "Khi đăng ký lại",
  "organization-subscription-contract-information": "Thông tin hợp đồng",
  "organization-subscription-contract-end-date": "Ngày kết thúc hợp đồng",
  "organization-subscription-contract-end-date-description": "Sau khi hợp đồng hết hạn, quyền quản trị viên tổ chức sẽ bị xóa, ngoại trừ Quản trị viên chính của tổ chức.",
  "organization-subscription-payment-method": "Hình thức thanh toán",
  "organization-subscription-subject-to-contract": "Theo hợp đồng",
  "organization-subscription-renewal-method": "Phương thức gia hạn",
  "organization-subscription-negotiation": "Thỏa luận",
  "organization-subscription-contract-end": "Kết thúc hợp đồng",
  "organization-subscription-contract-end-description-1": "Hợp đồng đã kết thúc.",
  "organization-subscription-contract-end-description-2": "Để tiếp tục sử dụng dịch vụ, vui lòng liên hệ với chúng tôi.",
  "organization-subscription-coupon-management-tab-menu-1": "Có sẵn",
  "organization-subscription-coupon-management-tab-menu-2": "Đã dùng",
  "organization-subscription-coupon-management-tab-menu-3": "Đã hết hạn",
  "organization-subscription-coupon-management-count": "00 mã giảm giá",
  "organization-subscription-coupon-management-apply-coupon": "Áp dụng mã giảm giá",
  "organization-subscription-coupon-management-none-1": "Chưa có mã giảm giá nào khả dụng.",
  "organization-subscription-coupon-management-none-2": "Chưa có mã giảm giá nào đã sử dụng hoặc hết hạn.",
  "organization-subscription-payment-history-count": "Thanh toán",
  "organization-subscription-payment-history-item": "Mục",
  "organization-subscription-payment-history-invoice": "Hóa đơn",
  "organization-subscription-payment-history-none": "Chưa có lịch sử thanh toán.",
  "organization-subscription-payment-history-canceled-date": "Ngày xử lý hoàn tiền",
  "organization-subscription-payment-history-fully-canceled": "Đã hủy toàn bộ",
  "organization-subscription-payment-history-partially-canceled": "Đã hủy một phần",
  "organization-subscription-change-billing-cycle": "Thay đổi chu kỳ thanh toán",
  "organization-subscription-change-billing-cycle-title": "Bạn có muốn thay đổi chu kỳ thanh toán không?",
  "organization-subscription-current-billing-cycle": "Chu kỳ thanh toán hiện tại",
  "organization-subscription-change-billing-cycle-description-1": "Sau thay đổi",
  "organization-subscription-change-billing-cycle-description-2": "Áp dụng từ lần thanh toán tiếp theo.",
  "organization-subscription-change-billing-cycle-success": "Đã thay đổi chu kỳ thanh toán.\nThay đổi sẽ được áp dụng từ lần thanh toán tiếp theo.",
  "organization-subscription-change-billing-cycle-fail": "Không thể thay đổi chu kỳ thanh toán.\nVui lòng thử lại.",
  "organization-subscription-change-billing-cycle-scheduled-1": "Sẽ chuyển sang thanh toán theo tháng từ lần thanh toán tiếp theo",
  "organization-subscription-change-billing-cycle-scheduled-2": "Sẽ chuyển sang thanh toán theo năm từ lần thanh toán tiếp theo",
  "organization-subscription-cancel-change": "Hủy thay đổi",
  "organization-subscription-cancel-subscription-description-2": "Chỉ tài khoản Quản trị viên chính có thể sử dụng các tính năng của tổ chức.",
  "organization-subscription-change-billing-cycle-scheduled-3": "Sẽ chuyển sang thanh toán theo tháng từ lần thử thanh toán tiếp theo",
  "organization-subscription-change-billing-cycle-scheduled-4": "Sẽ chuyển sang thanh toán theo năm từ lần thử thanh toán tiếp theo",
  "organization-subscription-change-billing-cycle-scheduled-5": "Sẽ chuyển sang thanh toán theo tháng khi đăng ký lại",
  "organization-subscription-change-billing-cycle-scheduled-6": "Sẽ chuyển sang thanh toán theo năm khi đăng ký lại",
  "organization-subscription-upgrade-plan": "Nâng cấp gói",
  "organization-subscription-upgrade-plan-immediately-applied": "Áp dụng ngay lập tức.",
  "organization-subscription-upgrade-settlement-details": "Chi tiết quyết toán nâng cấp",
  "organization-subscription-upgrade-subscription-fee-difference": "Chênh lệch phí đăng ký (còn lại {date} ngày)",
  "organization-subscription-upgrade-pro-remaining-amount": "Phần còn lại của gói Pro",
  "organization-subscription-upgrade-basic-unused-deduction": "Khấu trừ phần chưa dùng của gói Basic",
  "organization-subscription-upgrade-difference": "Chênh lệch",
  "organization-subscription-upgrade-credit-unit-price-difference": "Chênh lệch đơn giá Pro của credit đã nạp ({count})",
  "organization-subscription-upgrade-credit-difference-tooltip": "Đơn giá credit đã nạp khác nhau theo từng gói; đây là khoản chênh lệch để điều chỉnh credit đã nạp theo đơn giá của gói Pro.",
  "organization-subscription-upgrade-held-credit-count": "{count} credit đã nạp hiện có",
  "organization-subscription-upgrade-support-discount": "Giảm giá hỗ trợ nâng cấp (chênh lệch đơn giá Pro của credit đã nạp)",
  "organization-subscription-upgrade-description-1": "{count} credit đã nạp của bạn sẽ được giữ nguyên.",
  "organization-subscription-upgrade-description-2": "Phí gói Pro sẽ được tính từ ngày thanh toán tiếp theo.",
  "organization-subscription-upgrade-agree-check": "Tôi đồng ý với thanh toán và {term}.",
  "organization-subscription-upgrade-plan-success": "Đã nâng cấp gói.",
  "organization-subscription-upgrade-plan-fail": "Không thể nâng cấp gói.\nVui lòng thử lại.",
  "organization-subscription-change-plan": "Thay đổi gói",
  "organization-subscription-change-plan-title": "Bạn có muốn thay đổi gói không?",
  "organization-subscription-change-plan-success": "Đã thay đổi gói.\nThay đổi sẽ áp dụng từ lần thanh toán tiếp theo.",
  "organization-subscription-change-plan-fail": "Không thể thay đổi gói.\nVui lòng thử lại.",
  "organization-subscription-change-plan-scheduled": "Sẽ chuyển sang gói Pro khi đăng ký lại",
  "credit-title": "Số credit còn lại:",
  "common-contact-us": "Contact Us",
  "credit-banner": "Số credit",
  "credit-detail-button": "Xem chi tiết",
  "credit-management": "Quản lý credit",
  "credit-history-title": "Lịch sử xử lý credit",
  "credit-history-count": "Lịch sử xử lý",
  "credit-history-transaction": "Lịch sử xử lý",
  "credit-history-granted": "Được cấp phát",
  "credit-history-used": "Đã sử dụng",
  "credit-history-cancelled": "Đã hủy",
  "credit-history-revoked": "Bị thu hồi",
  "credit-history-table-amount": "Biến động",
  "credit-history-table-remaining": "Còn lại",
  "credit-history-table-related": "Liên quan",
  "credit-history-table-performed-by": "Người thực hiện",
  "credit-history-table-date": "Thời gian",
  "credit-history-table-credit-expiration": "Thời hạn sử dụng credit",
  "credit-history-table-revoked-reason-credit-expiration": "Bị thu hồi tự động do hết hạn credit",
  "credit-history-table-until": "đến {time}",
  "credit-history-table-revoked-reason-credit-refund": "Thu hồi do hoàn tiền",
  "credit-history-table-usage-details": "Chi tiết sử dụng",
  "credit-history-table-cancellation-details": "Chi tiết hủy",
  "credit-history-table-usage-details-info": "Đã sử dụng tổng cộng {count} credit",
  "credit-history-table-cancellation-details-info": "Đã hủy tổng cộng {count} credit",
  "credit-history-table-candidate-credit-count": "{candidateCount} ứng viên",
  "credit-history-table-candidate-credit-count-1": "{creditCount} credit mỗi ứng viên",
  "credit-history-table-none-data": "Chưa có lịch sử xử lý credit.",
  "credit-limit-description": "Nếu cần thêm credit, vui lòng liên hệ với chúng tôi qua mục {linkDom}.",
  "credit-certify-invitation-button": "Xem mô tả số credit",
  "credit-certify-invitation-limit": "Không thể mời ứng viên do thiếu credit",
  "credit-history-table-none-related": "Đánh giá đã bị xóa",
  "credit-history-top-up-credits": "Nạp thêm credit",
  "credit-history-top-up-credits-count": "Số credit cần nạp",
  "credit-history-top-up-credits-count-error": "Số lượng credit phải từ 1 đến 9,999.",
  "credit-history-top-up-credits-description-1": "Credit đã nạp sẽ không bị hết hạn và không biến mất ngay cả sau khi gói đăng ký kết thúc.\nTuy nhiên, chỉ có thể sử dụng khi đang trong thời gian đăng ký.",
  "credit-history-top-up-credits-description-2": "Thanh toán sẽ được thực hiện bằng phương thức thanh toán đã đăng ký trong {link}.",
  "credit-history-top-up-credits-agree-check": "Tôi đồng ý với {term} và điều kiện thanh toán/credit.",
  "credit-history-top-up-credits-make-payment": "Thanh toán",
  "credit-history-top-up-credits-success": "Đã hoàn tất nạp thêm credit.",
  "credit-history-top-up-credits-fail": "Không thể hoàn tất việc nạp thêm credit.\nVui lòng thử lại.",
  "credit-history-top-up-credits-restriction-info-1-title": "Không thể nạp thêm credit do không có gói đăng ký nào đang hoạt động",
  "credit-history-top-up-credits-restriction-info-2-title": "Không thể nạp thêm credit do gói đăng ký đã kết thúc",
  "credit-history-top-up-credits-restriction-info-2-description": "Để tiếp tục sử dụng dịch vụ, vui lòng đăng ký lại.",
  "credit-history-top-up-credits-restriction-info-3-title": "Gói Enterprise không thể nạp credit",
  "loading": "Đang tải",
  "loading-title": "Vui lòng đợi trong giây lát.",
  "404-title": "Không tìm thấy trang",
  "404-content": "Không thể tìm thấy trang bạn yêu cầu. \nVui lòng kiểm tra lại địa chỉ bạn đã nhập và thử lại.",
  "error-button": "Đi đến Trang chủ",
  "500-title": "Lỗi máy chủ nội bộ",
  "500-content": "Máy chủ gặp phải một tình huống bất ngờ nên không thể xử lý yêu cầu. \nVui lòng thử lại sau.",
  "400-title": "Trang web của chúng tôi hiện đang được bảo trì",
  "400-content": "Chúng tôi xin lỗi vì bất kỳ sự bất tiện nào có thể xảy ra. \nDo việc ổn định dịch vụ và cập nhật đang được tiến hành, và chúng tôi sẽ nhanh chóng khôi phục để bạn có thể trở lại hoạt động bình thường.",
  "dashboard-back-button": "Quay trở lại Dashboard",
  "common-wrong-approach-title": "Chúng tôi xin lỗi, có gì đó không đúng",
  "common-wrong-approach-content": "Vui lòng thử lại sau ít phút.",
  "common-ok": "OK",
  "learning-no-access-course": "Không có quyền truy cập vào khoá học này",
  "learning-no-access-course-description": "Bạn cần đăng ký khóa học trước để có thể tiếp tục.",
  "learning-no-access-course-confirm": "Đi đến Track",
  "learning-exercise-refresh-page": "Tải lại trang",
  "learning-exercise-request-fail": "Yêu cầu không thành công do lỗi kỹ thuật.\nVui lòng thử tải lại trang, và nếu vấn đề vẫn tiếp diễn, hãy liên hệ với {email} để được hỗ trợ.",
  "learning-finished-course": "Bạn đã hoàn thành khoá học này",
  "learning-finished-course-description": "Bạn có thể kiểm tra kết quả bằng cách quay lại track này.",
  "learning-back-to-track": "Quay trở lại Track",
  "learning-exercise": "Bài tập",
  "common-hour": " giờ",
  "common-min": " phút",
  "common-s": " giây",
  "common-points": "Điểm",
  "learning-easy": "Easy",
  "learning-medium": "Medium",
  "learning-hard": "Hard",
  "learning-view-progress": "Xem tiến độ",
  "learning-go": "Đi",
  "learning-course-outline": "Đề cương khoá học",
  "common-description": "Mô tả",
  "learning-out-put": "Kết quả",
  "learning-out-put-none-submit": "Dù không hiển thị kết quả, bạn vẫn có thể nộp câu trả lời. \nViệc chấm điểm sẽ dựa trên code mà bạn đã viết.",
  "learning-correct-answer": "Câu trả lời đúng",
  "learning-preview": "Xem trước",
  "common-course": "Khoá học",
  "learning-skill-count": "{count} Kỹ năng",
  "learning-exercise-count": "{count} Bài tập",
  "common-skill": "Kỹ năng",
  "learning-none-description": "Không có mô tả được cung cấp.",
  "learning-out-put-info": "Đây là kết quả cho code của bạn.",
  "learning-error-info": "Chúng tôi đã phát hiện lỗi trong code của bạn.",
  "learning-error-description": "Mô tả đã xảy ra lỗi",
  "learning-submit-answer": "Nộp câu trả lời",
  "learning-submit-answer-info": "Câu trả lời cho câu hỏi này sẽ được nộp.",
  "learning-exercise-finished": "Bạn đã hoàn thành bài tập này.",
  "learning-exercise-output-description": "Xem Mô tả Kết quả",
  "learning-output-description": "Mô tả Kết quả",
  "learning-exercise-complete-fail": "Bạn không thể hoàn thành được bài tập. \nVui lòng kiểm tra lại code bạn đã nộp.",
  "learning-hint-widget-click": "Nhấn vào đây để nhận gợi ý.",
  "learning-exercise-incorrect-answer": "Đây không phải là câu trả lời đúng.",
  "learning-correct": "Đúng",
  "learning-activity-widget-drop-code-here": "Kéo thả code vào đây",
  "learning-activity-widget-correct-code-herer": "Code đúng ở đây",
  "learning-activity-widget-drag-and-drop-code": "Kéo và thả code đúng để điền vào chỗ trống.",
  "learning-activity-widget-click-code": "Chọn code đúng để điền vào chỗ trống.",
  "learning-activity-widget-drag-and-drop-parts": "Kéo và thả các phần của code để sắp xếp chúng theo đúng thứ tự.",
  "learning-activity-widget-click-parts": "Chọn các phần của code để sắp xếp chúng theo đúng thứ tự.",
  "learning-chart": "Biểu đồ",
  "learning-lnstruction": "Hướng dẫn",
  "learning-multiple-choice": "Trắc nghiệm",
  "learning-short-answer-type": "Tự luận ngắn",
  "learning-essay-type": "Tự luận",
  "learning-answer-placeholder": "Điền câu trả lời.",
  "learning-show-correct-answer": "Hiển thị đáp án đúng",
  "learning-answer": "Câu trả lời của bạn",
  "learning-annotation-widget-1": "Viết code ở đây",
  "learning-annotation-widget-2": "Không thay đổi đoạn code bên dưới cho mục đích tính điểm",
  "learning-annotation-widget-3": "Dữ liệu đã cho",
  "learning-annotation-widget-4": "Điền vào chỗ trống trong đoạn code đã cho bằng đoạn code phù hợp",
  "learning-annotation-widget-5": "Tái cấu trúc code dưới đây để đáp ứng các yêu cầu đã được đưa ra",
  "term-copyright": "ⓒ {year} Codepresso, Inc. Mọi quyền đã được bảo lưu. Nghiêm cấm sao chép hoặc phân phối tài liệu này khi chưa được phép.",
  "learning-directory-select-files": "Hãy chọn một tệp từ thư mục.",
  "learning-reset-select-files": "Hãy chọn các tệp cần cài đặt lại",
  "common-reset": "Cài đặt lại",
  "learning-reset-select-files-success": "Các tệp đã chọn đã được cài đặt lại.",
  "learning-reset-select-files-fail": "Chúng tôi không thể cài đặt lại các tệp đã chọn.\nVui lòng thử lại.",
  "learning-open-directory": "Mở Thư mục",
  "learning-close-directory": "Đóng Thư mục",
  "learning-my-output": "Kết quả của tôi",
  "learning-correct-output": "Kết quả đúng",
  "learning-front-exercise-delay": "Việc xem trước có thể mất một khoảng thời gian chờ, tùy thuộc vào môi trường PC của bạn.",
  "learning-front-exercise-download-fail": "Việc tải xuống các tệp cài đặt cần thiết cho trải nghiệm thực hành đã thất bại. \nVui lòng thử tải lại trang, và nếu vấn đề vẫn tiếp diễn, hãy liên hệ với support@codepresso.io để được hỗ trợ.",
  "learning-reset-editor": "Bạn có thể cài đặt lại editor.",
  "learning-stop-code": "Dừng Code",
  "learning-file-count": "{count} Tệp",
  "learning-copy-clipboard": "Đã được sao chép vào bộ nhớ đệm.",
  "learning-limit-permission-title": "Bạn không có quyền truy cập nội dung này",
  "learning-limit-permission-description": "Liên hệ với chúng tôi qua mục {link} để được cấp quyền truy cập.",
  "learning-hide-top-bottom-bars": "Ẩn thanh trên/dưới",
  "learning-show-top-bottom-bars": "Hiện thanh trên/dưới",
  "learning-front-preview-guide": "Các nội dung chỉnh sửa trong code đã được phản ánh ở phần xem trước.",
  "challenges-title": "Thử thách",
  "challenges-description": "Khẳng định kỹ năng của bạn và bứt phá ngay hôm nay bằng cách giải quyết các thử thách công nghệ thực tế.",
  "common-live": "Đang diễn ra",
  "common-upcoming": "Sắp diễn ra",
  "common-closed": "Đóng",
  "challenges-start-days": "Sắp diễn ra vào {day} ngày tới",
  "challenges-start-tomorrow": "Diễn ra vào ngày mai",
  "challenges-start-today": "Diễn ra vào hôm nay",
  "challenges-closed-days": "Sắp kết thúc vào {day} ngày tới",
  "challenges-closed-tomorrow": "Kết thúc vào ngày mai",
  "challenges-closed-today": "Kết thúc vào hôm nay",
  "challenges-entry-complete": "Tham gia thành công",
  "challenges-participants-count": "{totalCount} Người tham gia",
  "challenges-certificate": "Chứng nhận",
  "common-all": "Tất cả",
  "challenges-count": "Thử thách",
  "common-filters": "Lọc",
  "challenges-none-data": "Chưa có thử thách nào được đăng ký.",
  "common-load-more": "Xem thêm",
  "challenges-leaderboard-submitted-questions-showing-participants": "Bảng xếp hạng chỉ hiển thị đối với những người đã nộp bài thi.",
  "common-period": "Khoảng thời gian",
  "challenges-join-challenge": "Tham gia thử thách",
  "common-overview": "Tổng quan",
  "challenges-leaderboard": "Bảng xếp hạng",
  "common-guidelines": "Hướng dẫn",
  "challenges-winner": "Người chiến thắng",
  "challenges-final-ranking-info": "Xếp hạng và điểm số cuối cùng sẽ được hiển thị sau khi quản trị viên chấm điểm.",
  "challenges-participant": "Người tham gia",
  "common-delete-member": "Thành viên đã xóa tài khoản",
  "common-score": "Điểm",
  "challenges-submit-questions": "Câu hỏi đã nộp",
  "challenges-total-questions": "/ Tổng số câu hỏi",
  "challenges-last-submission": "Ngày nộp cuối cùng",
  "challenges-none-participants-data": "Chưa có người tham gia.",
  "challenges-guidelines": "Hướng dẫn thi",
  "challenges-authentication-code-title": "Nhập mã xác minh",
  "challenges-authentication-code-description": "Nhập mã xác minh được chỉ định để tham gia thử thách này.",
  "challenges-authentication-code-placeholder": "Mã xác minh",
  "challenges-authentication-code-incorrect": "Mã xác minh không đúng.",
  "challenges-anti-cheating-guidance": "Hướng dẫn về chống gian lận:",
  "challenges-anti-cheating-info-1": "Để đảm bảo sự công bằng và ngăn chặn hành vi gian lận, tính năng giám sát và ghi hình trực tiếp sẽ được kích hoạt.",
  "challenges-anti-cheating-info-2": "Hãy lưu ý một số hành vi sau sẽ bị coi là gian lận:",
  "challenges-anti-cheating-screen-exit-detection": "Rời khỏi màn hình",
  "challenges-anti-cheating-screen-exit-detection-info-1": "Nếu hành vi này xảy ra từ 2 lần trở lên, bạn có thể bị loại khỏi kỳ thi.",
  "challenges-anti-cheating-screen-exit-detection-info-2": "Tuy nhiên, trong các trường hợp bất khả kháng như gửi yêu cầu hỗ trợ hoặc thực hiện thao tác cần thiết trong quá trình làm bài thi, thí sinh sẽ không bị xử lý vi phạm. Vì vậy, thí sinh hãy yên tâm tiếp tục làm bài.",
  "challenges-anti-cheating-keyboard-shortcuts-restriction-and-detection": "Cố gắng sử dụng các phím tắt trái phép",
  "challenges-anti-cheating-multiple-monitor-restriction-and-detection": "Cố gắng sử dụng nhiều màn hình",
  "challenges-anti-cheating-copy-cut-paste-detection": "Sao chép, cắt và dán code từ bên ngoài",
  "challenges-anti-cheating-face-voice-recording": "Thay đổi hoặc vô hiệu hóa cài đặt camera hoặc micrô",
  "challenges-anti-cheating-face-voice-recording-info-1": "Điều này cũng áp dụng đối với trường hợp camera bị cản tầm nhìn hoặc khó nhận diện hình ảnh của ứng viên.",
  "challenges-agree-rules-title": "Vui lòng đồng ý với hướng dẫn trước khi bắt đầu",
  "challenges-agree-rules-description": "Tôi đồng ý rằng tôi đã đọc và hiểu hướng dẫn.",
  "common-agree": "Đồng ý",
  "common-confirm": "Xác nhận",
  "challenges-proctoring-full-screen-error": "Để tiếp tục thử thách, bạn phải chia sẻ toàn bộ màn hình.",
  "challenges-back-to-challenge-detail": "Quay lại phần Thử thách",
  "challenges-finish-challenge-title": "Bạn có muốn kết thúc thử thách này không?",
  "common-cancel": "Huỷ",
  "challenges-finished-title": "Thử thách đã kết thúc",
  "challenges-finished-description": "Thời gian làm bài đã kết thúc.\nCảm ơn bạn đã tham gia thử thách.",
  "common-dashboard": "Dashboard",
  "common-skillCertify": "SkillCertify",
  "common-manageAssessment": "Quản lý đánh giá",
  "common-takeAssessment": "Tham gia đánh giá",
  "common-skillMonitor": "SkillMonitor",
  "common-skillAdvance": "SkillAdvance",
  "common-adaptiveLecture": "SkillFit",
  "advance-learn": "Học",
  "advance-practice": "Luyện tập",
  "common-choose-language": "Chọn ngôn ngữ",
  "dashboard-info-greetings": "Xin chào,",
  "dashboard-info-nickName": "{name}",
  "common-closed-assessment": "Số lượng đánh giá đã kết thúc",
  "dashboard-total-assessments": "Tổng số lượng bài đánh giá",
  "dashboard-completed-candidates": "Số các ứng viên đã hoàn thành",
  "dashboard-total-candidates": "Tổng số ứng viên",
  "dashboard-completed-learning": "Số bài học đã hoàn thành",
  "dashboard-total-learning": "Tổng số bài học",
  "dashboard-learning-points": "Điểm học tập",
  "dashboard-total-point": "Tổng",
  "dashboard-completed-practice": "Số luyện tập đã hoàn thành",
  "dashboard-total-practice": "Tổng số luyện tập",
  "dashboard-completed-assessments": "Số lượng đánh giá đã hoàn thành",
  "dashboard-created-assessments": "Đánh giá đã tạo",
  "dashboard-candidates": "Số ứng viên",
  "common-sample": "Mẫu",
  "skillCertify-none-created-assessment": "Chưa có bài đánh giá nào được tạo.",
  "skillCertify-internal-assessment": "Đánh giá năng lực nhân sự nội bộ",
  "skillCertify-external-assessment": "Đánh giá tài năng bên ngoài",
  "dashboard-invited-assessments": "Đánh giá được mời",
  "dashboard-sample-assessments": "Các đánh giá mẫu",
  "skillCertify-none-invited-assessment": "Chưa có lời mời tham gia đánh giá nào.",
  "advance-my-learning": "Học tập của tôi",
  "advance-my-learning-more": "Xem học tập của tôi",
  "advance-position-learn": "Vị trí học tập:",
  "advance-permission-disable": "Bạn không có quyền truy cập nội dung này.\nLiên hệ với chúng tôi qua mục Contact Us để được cấp quyền truy cập.",
  "advance-position-info": "Thông tin Khóa học & Kỹ năng",
  "advance-learn-none-data": "Bạn chưa bắt đầu học.",
  "advance-my-practice": "Luyện tập của tôi",
  "advance-my-practice-more": "Xem luyện tập của tôi",
  "advance-position-practice": "Vị trí luyện tập",
  "advance-practice-none-data": "Bạn chưa bắt đầu luyện tập.",
  "advance-find-track": "Khám phá các lộ trình",
  "advance-my-learn-sub-description": "Tổng quan về tất cả các bài học bạn đã bắt đầu.",
  "common-in-progress": "Đang tiến hành",
  "common-completed": "Hoàn thành",
  "filter-field": "Lĩnh vực",
  "filter-select": "{count} Đã chọn",
  "advance-my-practice-sub-description": "Tổng quan về tất cả các bài luyện tập bạn đã bắt đầu.",
  "advance-learn-sub-description": "Học hỏi các kỹ năng và xây dựng năng lực công việc để phát triển sự nghiệp của bạn.",
  "advance-none-track": "Chưa có chương trình học nào được đăng ký.",
  "advance-practice-sub-description": "Hãy kiểm tra kỹ năng và năng lực thực tế của bạn qua các bài đánh giá thực hành.",
  "advance-level-count": "{count} Cấp độ",
  "advance-course-count": "{count} Khoá học",
  "advance-related-practice": "Luyện tập liên quan",
  "advance-related-practice-info": "Kiểm tra để chắc chắn rằng bạn hiểu đúng nội dung đã học.",
  "common-point-count": "{point} Điểm",
  "advance-not-start": "Khoá",
  "advance-pre-start": "Trước khi bắt đầu",
  "advance-ongoing": "Đang tiến hành",
  "advance-related-learn": "Học tập liên quan",
  "advance-related-learn-info": "Hãy học và cải thiện những phần bạn còn thiếu.",
  "advance-my-level": "Trình độ {level}",
  "skillCertify-manage-assessment-description": "Dễ dàng tạo các bài đánh giá tuỳ chỉnh mà bạn cần và dễ dàng chỉnh sửa, kiểm tra và xóa các bài đánh giá hiện có.",
  "skillCertify-search-placeholder": "Tìm kiếm bằng tên bài đánh giá",
  "common-status": "Trạng thái",
  "skillCertify-assessment-count": "Bài đánh giá",
  "skillCertify-create-assessment": "Tạo đánh giá",
  "common-information": "Thông tin",
  "skillCertify-type": "Thể loại",
  "common-question-info": "Số câu hỏi",
  "common-question-count": "{count} Câu hỏi",
  "common-duration": "Thời lượng",
  "skillCertify-more-information": "Thông tin khác",
  "skillCertify-proctoring": "Giám sát",
  "skillCertify-constructor": "Được tạo bởi",
  "skillCertify-creation-date": "Vào",
  "skillCertify-tracks-settings": "Cài đặt Tracks",
  "skillCertify-assessment-set-title-to-level-plural": "{title} - {level} và {count}",
  "skillCertify-assessment-set-title-to-level-singular": "{title} - {level}",
  "skillCertify-tracks-information-detail": "Chi tiết thông tin track",
  "skillCertify-pre-start": "Trước khi bắt đầu",
  "skillCertify-invited": "Đã mời",
  "skillCertify-ready": "Sẵn sàng",
  "skillCertify-started": "Đã bắt đầu",
  "skillCertify-completed": "Đã hoàn thành",
  "skillCertify-view-actual-question": "Xem câu hỏi thực tế",
  "skillCertify-actual-question": "Câu hỏi thực tế",
  "skillCertify-api-reference": "Tài liệu tham khảo",
  "skillCertify-api-reference-description": "Bật cài đặt này cho phép ứng viên xem tài liệu tham khảo trong suốt quá trình tham gia đánh giá.",
  "skillCertify-api-reference-view": "Xem Tài liệu tham khảo",
  "skillCertify-add-track": "Thêm Track",
  "skillCertify-add-track-success": "Track đã được thêm thành công.",
  "skillCertify-set-tip": "Lựa chọn trình độ.",
  "skillCertify-recommend-time": "Thời lượng đề xuất",
  "skillCertify-recommend-time-tip": "Thời gian đề xuất để hoàn thành track.",
  "skillCertify-remove-track": "Xóa Track",
  "skillCertify-track-remove-title": "Bạn có chắc chắn muốn xóa track này không?",
  "common-remove": "Xóa",
  "skillCertify-remove-track-success": "Đã xóa thành công track.",
  "skillCertify-reset-track": "Cài đặt lại Track",
  "skillCertify-category": "Danh mục",
  "advance-track-name-placeholder": "Tìm kiếm bằng tên track",
  "advance-track-count": "Track | Tracks",
  "advance-track": "Track | Tracks",
  "skillCertify-view-description": "Xem Mô tả",
  "advance-more-track": "Tìm hiểu thêm về track này.",
  "skillCertify-view-guide": "Xem Hướng dẫn",
  "advance-guide": "Hướng dẫn",
  "advance-level": "Trình độ",
  "advance-level-general": "General",
  "advance-level-entry": "Entry",
  "advance-level-beginner": "Beginner",
  "advance-level-intermediate": "Intermediate",
  "advance-level-professional": "Professional",
  "skillCertify-view-questions": "Xem các câu hỏi",
  "skillCertify-select": "Lựa chọn",
  "skillCertify-select-info": "Một bộ câu hỏi trong mỗi cấp độ sẽ được lựa chọn ngẫu nhiên.",
  "skillCertify-basic-info": "Thông tin cơ bản",
  "skillCertify-assessment-name": "Tên bài đánh giá",
  "skillCertify-assessment-name-placeholder": "Điền tên cho bài đánh giá.",
  "skillCertify-assessment-internal": "Đánh giá năng lực nhân sự nội bộ",
  "skillCertify-assessment-external": "Đánh giá tài năng bên ngoài",
  "skillCertify-assessment-internal-description": "Đánh giá năng lực nhân sự nội bộ có thể giúp bạn chẩn đoán tổ chức của mình để hiểu rõ năng lực của nhân viên hoặc quản lý nguồn nhân lực.",
  "skillCertify-assessment-external-description": "Đánh giá tài năng bên ngoài có thể được sử dụng để đánh giá những người ngoài tổ chức của bạn, chẳng hạn như để tuyển dụng nhân tài và lựa chọn đối tác.",
  "skillCertify-period-info": "Thí sinh chỉ có thể tham gia đánh giá trong khoảng thời gian bạn đã cài đặt.",
  "common-open-date": "Ngày bắt đầu",
  "common-at": "",
  "common-close-date": "Ngày kết thúc",
  "skillCertify-period-error-invalid-both": "Ngày và thời gian kết thúc không thể sớm hơn ngày và thời gian bắt đầu.",
  "skillCertify-time-zone": "Múi Giờ",
  "skillCertify-time-zone-placeholder": "Tìm kiếm múi giờ",
  "common-optional": "Tuỳ chọn | - Tuỳ chọn",
  "skillCertify-candidates-find-tip": "Ứng viên có thể xem phần mô tả của bài đánh giá này.",
  "skillCertify-assessment-description-placeholder": "Điền mô tả cho bài đánh giá của bạn.",
  "skillCertify-assessment-duration-tip": "Thời lượng sẽ được tự động cài đặt theo từng track, bạn có thể thay đổi nếu cần.",
  "skillCertify-assessment-duration-time-limit": "Giới hạn thời gian",
  "common-duration-unlimited": "Không giới hạn",
  "skillCertify-assessment-duration-error": "Bạn phải cài đặt thời lượng.",
  "skillCertify-assessment-duration-change": "Thời lượng đã được thay đổi dựa trên cài đặt trước đó của bạn.",
  "common-previous": "Trước",
  "skillCertify-proctoring-description": "Chúng tôi khuyến khích sử dụng các tính năng giám sát để đảm bảo sự công bằng và ngăn chặn các hành vi gian lận.",
  "skillCertify-no-proctoring": "Không sử dụng",
  "skillCertify-basic-proctoring": "Cơ bản",
  "skillCertify-basic-proctoring-sub": "Trình duyệt web",
  "skillCertify-advanced-proctoring": "Nâng cao",
  "skillCertify-advanced-proctoring-sub": "Chương trình Proctive",
  "skillCertify-proctoring-screen-exit-detection": "Phát hiện rời khỏi màn hình",
  "skillCertify-proctoring-screen-exit-detection-description": "Tính năng này phát hiện khi ứng viên rời khỏi màn hình bài đánh giá trong quá trình làm bài.",
  "skillCertify-proctoring-keyboard-shortcuts-restriction-and-detection": "Hạn chế và phát hiện sử dụng phím tắt",
  "skillCertify-proctoring-keyboard-shortcuts-restriction-and-detection-description-1": "Tính năng này giới hạn các phím tắt không hợp lệ và phát hiện mọi hành vi cố gắng sử dụng chúng trong quá trình làm bài đánh giá.",
  "skillCertify-proctoring-keyboard-shortcuts-restriction-and-detection-description-2": "Các phím tắt trái phép bao gồm:",
  "skillCertify-proctoring-keyboard-shortcuts-restriction-and-detection-description-3": "những phím liên quan đến việc lưu trang web, chụp ảnh màn hình, xem các nguồn tham khảo, mở các công cụ hỗ trợ cho lập trình viên.",
  "skillCertify-proctoring-multiple-monitor-restriction-and-detection": "Hạn chế và phát hiện việc sử dụng nhiều màn hình",
  "skillCertify-proctoring-multiple-monitor-restriction-and-detection-description": "Tính năng này giới hạn việc sử dụng nhiều màn hình và phát hiện mọi hành vi cố ý sử dụng trong quá trình làm bài đánh giá.",
  "skillCertify-proctoring-copy-cut-paste-detection": "Phát hiện Sao chép/Cắt/Dán",
  "skillCertify-proctoring-copy-cut-paste-detection-description": "Tính năng này phát hiện khi ứng viên sao chép, cắt hoặc dán code hoặc văn bản trong quá trình làm bài đánh giá.",
  "skillCertify-proctoring-partial-screen--recording": "Ghi hình một phần màn hình (khi phát hiện gian lận)",
  "skillCertify-proctoring-partial-screen--recording-description-1": "Tính năng này ghi lại màn hình tại thời điểm xảy ra hành vi gian lận trong quá trình làm bài đánh giá.",
  "skillCertify-proctoring-partial-screen--recording-description-2": "Khi phát hiện gian lận, nhiều ảnh chụp màn hình sẽ được ghi lại và dựa trên đó, một video riêng sẽ được tạo cho mỗi hành vi gian lận.",
  "skillCertify-proctoring-partial-screen--recording-description-3": "Video được lưu trữ an toàn và sẽ bị xóa vĩnh viễn sau 30 ngày.",
  "skillCertify-proctoring-partial-screen--recording-description-4": "Video sẽ khả dụng sau khi bài đánh giá được chấm điểm bởi quản trị viên.",
  "skillCertify-proctoring-full-screen-recording": "Ghi toàn bộ màn hình (toàn bộ quá trình đánh giá)",
  "skillCertify-proctoring-full-screen-recording-description-1": "Màn hình sẽ được ghi lại từ khi bắt đầu đến khi kết thúc bài đánh giá.",
  "skillCertify-proctoring-full-screen-recording-description-2": "Thời điểm xảy ra hành vi gian lận sẽ được ghi nhận, cho phép quản trị viên xác định và xem lại các đoạn video tương ứng trong bản ghi.",
  "skillCertify-proctoring-face-voice-recording": "Ghi hình khuôn mặt và giọng nói",
  "skillCertify-proctoring-face-voice-recording-description-1": "Ứng viên cần thiết lập camera và micrô trước khi bắt đầu bài đánh giá.",
  "skillCertify-proctoring-face-voice-recording-description-2": "Tính năng này ghi lại khuôn mặt và giọng nói của ứng viên trong quá trình làm bài đánh giá.",
  "skillCertify-assessment-create-success": "Bài đánh giá đã được tạo thành công.",
  "skillCertify-assessment-create-fail": "Chúng tôi không thể tạo bài đánh giá này.\nVui lòng thử lại.",
  "skillCertify-assessment-info": "Thông tin đánh giá",
  "skillCertify-candidates-list": "Ứng viên",
  "common-delete": "Xóa",
  "skillCertify-assessment-delete-title": "Bạn có chắc chắn muốn xóa bài đánh giá này không?",
  "skillCertify-assessment-delete-info-1": "Kết quả đánh giá của tất cả các ứng viên sẽ bị xóa.",
  "skillCertify-assessment-delete-info-2": "Khi bạn nhập 'Xóa' thì nút [Xóa] sẽ được kích hoạt.",
  "skillCertify-assessment-delete-success": "Bài đánh giá này đã được xóa thành công.",
  "skillCertify-assessment-delete-fail": "Chúng tôi không thể xóa bài đánh giá này.\nVui lòng thử lại.",
  "common-modify": "Sửa",
  "skillCertify-modify-limit-title": "Không thể sửa bài đánh giá này",
  "skillCertify-modify-limit-description": "Bạn không thể sửa bởi vì các ứng viên đã bắt đầu bài đánh giá này.",
  "common-update": "Cập nhật",
  "skillCertify-modify-success": "Bài đánh giá đã được cập nhật.",
  "skillCertify-modify-fail": "Chúng tôi không thể cập nhật bài đánh giá này.\nVui lòng thử lại.",
  "common-invite": "Mời",
  "skillCertify-invite-candidates": "Mời các ứng viên",
  "skillCertify-invite-candidates-description": "Các email để mời có thể được thêm bằng dấu phẩy hoặc phím Enter.\nMột khi các ứng viên bắt đầu, bạn sẽ không thể chỉnh sửa bài đánh giá.",
  "skillCertify-invite-candidates-email-invalid": "Email '{email}' không hợp lệ.",
  "skillCertify-invite-candidates-success": "Lời mời tham gia đánh giá đã được gửi tới {count} ứng viên.",
  "skillCertify-invite-candidates-fail": "Chúng tôi không thể mời {count} ứng viên. \nVui lòng thử lại.",
  "skillCertify-invite-candidates-duplicate-count": "Đã có {count} ứng viên được mời\nBạn có muốn mời sau khi xóa các mục trùng lặp không?",
  "skillCertify-invite-candidates-duplicate-description": "Sau khi xóa các mục trùng lặp, chỉ gửi lời mời tới các ứng viên mới.",
  "skillCertify-invite-candidates-duplicate-warning": "Có các ứng viên đã được mời.",
  "learning-start-assessment": "Bắt đầu Đánh giá",
  "skillCertify-search-user-placeholder-new": "Tìm kiếm bằng họ và tên hoặc email",
  "skillCertify-candidate-report": "Báo cáo",
  "skillCertify-score-rank": "Xếp hạng điểm",
  "skillCertify-skill-acquisition-rate-rank": "Xếp hạng tỷ lệ đạt kỹ năng",
  "skillCertify-set-average-skill-acquisition-rate-info": "Tỷ lệ đạt kỹ năng trung bình của tất cả các track.",
  "skillCertify-candidate-tracks-result-button": "Xem dữ liệu kết quả các track",
  "skillCertify-assessment-score-rank": "Xếp hạng điểm đánh giá",
  "skillCertify-assessment-score": "Điểm đánh giá",
  "skillCertify-assessment-time-taken": "Thời gian làm bài đánh giá",
  "skillCertify-assessment-skill-acquisition-rate-rank": "Xếp hạng tỷ lệ đạt kỹ năng trong đánh giá",
  "skillCertify-assessment-skill-acquisition-rate": "Tỷ lệ đạt kỹ năng trong đánh giá",
  "profile-full-name": "Họ và tên",
  "common-link-copy": "Liên kết đã được sao chép vào bộ nhớ đệm.",
  "skillCertify-candidate-count": "Ứng viên",
  "skillCertify-candidate-info": "Thông tin ứng viên",
  "skillCertify-candidate-last-record": "Bản ghi cuối cùng",
  "skillCertify-candidate-invited-date": "Được mời vào",
  "skillCertify-candidate-ready-date": "Sẵn sàng vào",
  "skillCertify-candidate-started-date": "Đã bắt đầu vào",
  "skillCertify-candidate-completed-date": "Đã hoàn thành vào",
  "common-time-taken": "Thời gian đã sử dụng",
  "common-view": "Xem",
  "skillCertify-rank": "Xếp hạng",
  "skillCertify-candidate-resend-email": "Gửi lại email",
  "skillCertify-candidate-resend-email-description": "Bạn có muốn gửi lại lời mời tham gia đánh giá tới '{email}'",
  "common-resend": "Gửi lại",
  "skillCertify-candidate-resend-email-success": "Chúng tôi đã gửi lại lời mời tham gia đánh giá tới '{email}'.",
  "skillCertify-candidate-resend-email-fail": "Chúng tôi không thể gửi lời mời tham gia đánh giá tới '{email}'.\nVui lòng thử lại.",
  "skillCertify-set-average-score-info": "Tổng điểm trung bình của tất cả các track.",
  "skillCertify-action-timeline": "Thời gian biểu",
  "skillCertify-action-record-count": "Bản ghi",
  "skillCertify-candidate-assessment-result": "Kết quả đánh giá",
  "skillCertify-score-grading": "Đang chấm điểm",
  "skillCertify-score-none-description": "Việc chấm điểm thủ công của quản trị viên có thể mất một khoảng thời gian.",
  "skillCertify-candidate-report-button": "Xem Báo cáo",
  "common-read-more": "Đọc thêm",
  "skillCertify-candidate-none-data": "Không có ứng viên nào.",
  "skillCertify-candidate-select": "{count} Ứng viên đã chọn",
  "skillCertify-delete-candidates": "Xóa ứng viên",
  "skillCertify-candidate-delete-1": "Bạn có chắc chắn muốn xóa",
  "skillCertify-candidate-delete-2": "ứng viên không?",
  "skillCertify-candidate-delete-description": "Kết quả đánh giá của ứng viên cũng sẽ bị xóa.",
  "skillCertify-candidate-delete-success": "Đã xóa thành công {count} ứng viên.",
  "skillCertify-candidate-delete-fail": "Chúng tôi không thể xóa {count} ứng viên.\nVui lòng thử lại.",
  "learning-view-guidelines": "Xem hướng dẫn",
  "learning-continue-assessment": "Tiếp tục đánh giá",
  "skillCertify-account-miss-match": "Bạn không thể truy cập vì thông tin tài khoản của bạn không khớp",
  "skillCertify-account-miss-match-description": "Tài khoản đang được đăng nhập hiện tại không khớp với tài khoản đã nhận email mời.\nVui lòng đăng xuất và đăng nhập lại, nếu vấn đề này vẫn tiếp diễn, vui lòng liên hệ với quản trị viên.",
  "skillCertify-limit-permission-title": "Bạn không có quyền tham gia bài đánh giá này",
  "skillCertify-limit-permission-description": "Hãy liên hệ với quản trị viên để được cấp quyền tham gia.",
  "skillCertify-assessment-duration-guide": "Kiểm tra thời lượng trước khi bắt đầu bài đánh giá này",
  "skillCertify-assessment-duration-description-1": "Thời lượng được cài đặt dựa trên ngày kết thúc của bài đánh giá.",
  "skillCertify-assessment-duration-description-2": "Thời lượng được cài đặt : {hour} giờ {minute} phút",
  "skillCertify-assessment-guidelines": "Hướng dẫn thi",
  "learning-assessment-guide-line-description-1": "Thí sinh vui lòng tham gia thi bằng {element}.",
  "learning-assessment-guild-line-element-1": "Google Chrome",
  "learning-assessment-guide-line-description-2": "Nghiêm cấm các hành vi sao chép hoặc chụp màn hình các câu hỏi.",
  "learning-assessment-guide-line-description-3": "Nghiêm cấm các hành vi đăng tải lên mạng hoặc chia sẻ với người khác những thông tin liên quan đến câu hỏi hoặc câu trả lời trong bài thi.",
  "learning-assessment-guide-line-description-4": "Chúng tôi không chịu trách nhiệm về bất kỳ sự cố kỹ thuật nào có thể xảy ra trong quá trình thi hoặc bất kỳ bất lợi nào do việc không tuân thủ hướng dẫn, quy tắc gây ra.",
  "learning-assessment-guide-line-description-5": "Thi sinh vui lòng tham gia cuộc thi tại một địa điểm có kết nối internet ổn định. Tránh sử dụng mạng công cộng tại quán cà phê hoặc thư viện.",
  "learning-assessment-guide-line-description-6": "Việc quản lý thời gian làm bài thi hoàn toàn là trách nhiệm của thí sinh, và nếu không nộp bài thi trước thời gian quy định sẽ bị phạt.",
  "learning-assessment-guide-line-description-7": "Bạn có thể sử dụng tính năng lưu code trong quá trình thực hành.\nCác phím tắt để lưu code như sau.{element}",
  "learning-assessment-guild-line-element-2": "Đối với Windows: Ctrl + S",
  "learning-assessment-guild-line-element-3": "Đối với MacBook và iMac: Command + S",
  "learning-assessment-guide-line-description-8": "Các hành vi như sử dụng Chat GPT hoặc các chương trình hỗ trợ tương tự khác có thể dẫn đến việc nhận điểm 0; điều này sẽ được xác minh thông qua giải pháp chống gian lận.",
  "learning-assessment-guide-line-description-9": "Mọi hành vi gian lận trong quá trình thi sẽ được hệ thống ghi lại và có thể được báo cáo cho quản trị viên.",
  "learning-assessment-guide-line-description-10": "Nếu không sử dụng hoặc bị gián đoạn giữa chừng trong khi sử dụng phần mềm giải pháp chống gian lận, kết quả thi có thể bị vô hiệu.",
  "learning-assessment-guide-line-description-for-mac-1": "Để sử dụng giải pháp chống gian lận, thí sinh sử dụng MacBook và iMac phải cấp quyền truy cập tính năng ghi màn hình.",
  "learning-assessment-guide-line-description-for-mac-2": "Hướng dẫn thiết lập như sau.",
  "learning-assessment-guide-line-description-for-mac-3": "Menu Apple → Cài đặt hệ thống → Bảo mật & quyền riêng tư → Ghi màn hình → Mở khóa → Chọn Google Chrome → Khởi động lại trình duyệt",
  "learning-assessment-guide-line-description-for-mac-4": "Menu Apple → Cài đặt hệ thống → Bảo mật & quyền riêng tư → Ghi màn hình → Mở khóa → Chọn Proctive → Khởi động lại Proctive",
  "learning-assessment-guide-line-description-11": "Mọi bất lợi do không tuân thủ các hướng dẫn và quy tắc của phần mềm giải pháp chống gian lận thí sinh sẽ phải hoàn toàn chịu trách nhiệm.",
  "common-question": "Câu hỏi",
  "skillCertify-assessment-outline": "Tóm tắt đánh giá",
  "skillCertify-assessment": "Đánh giá",
  "skillCertify-api-reference-info": "Bạn có thể xem tài liệu tham khảo.",
  "common-description-button": "Mở Mô tả trong Popup",
  "learning-finish": "Kết thúc đánh giá",
  "skillCertify-assessment-finish-question-title": "Bạn có muốn kết thúc bài đánh giá này không?",
  "skillCertify-assessment-finish-question-description-success-submitted": "Tất cả các câu trả lời đã được nộp.",
  "skillCertify-assessment-finish-question-description-not-submitted": "Vẫn còn một số câu trả lời chưa được nộp, vui lòng nộp câu trả lời tương ứng.",
  "skillCertify-assessment-finish-question-description-common": "Nếu bây giờ bạn kết thúc bài đánh giá, bạn sẽ không thể xem lại hoặc chỉnh sửa nữa.",
  "skillCertify-assessment-finish-question-description-check": "Vui lòng kiểm tra lại một lần nữa.",
  "skillCertify-assessment-finish-question-button": "Kết thúc",
  "skillCertify-caution": "Cảnh báo",
  "skillCertify-caution-tab-switch": "Đã xác định các hành vi rời khỏi màn hình. \nViệc này sẽ được thông báo cho quản trị viên, vì vậy không rời khỏi màn hình cho đến khi bạn kết thúc bài thi.",
  "common-continue": "Tiếp tục",
  "skillCertify-caution-tab-toast": "Việc này sẽ được thông báo cho quản trị viên, vì vậy không rời khỏi màn hình cho đến khi bạn kết thúc bài thi.",
  "skillCertify-caution-short-cut-1": "Đã xác định hành vi sử dụng phím tắt trái phép. \nViệc này sẽ được báo cáo cho quản trị viên, vì vậy không sử dụng các phím tắt trái phép cho đến khi bạn kết thúc bài thi. ",
  "skillCertify-caution-short-cut-2": "Các phím tắt liên quan đến các hành vi dưới đây không được phép sử dụng.",
  "skillCertify-caution-short-cut-key-word-1": "Lưu trang web",
  "skillCertify-caution-short-cut-key-word-2": "Chụp ảnh màn hình",
  "skillCertify-caution-short-cut-key-word-3": "Xem các nguồn tham khảo",
  "skillCertify-caution-short-cut-key-word-4": "Mở các công cụ hỗ trợ cho lập trình viên",
  "skillCertify-caution-short-cut-toast": "Việc này sẽ được báo cáo cho quản trị viên, vì vậy không sử dụng các phím tắt trái phép cho đến khi bạn kết thúc bài thi.",
  "skillCertify-caution-multiple-monitor": "Đã xác định hành vi sử dụng nhiều màn hình. \nViệc này sẽ được báo cáo cho quản trị viên, vì vậy không sử dụng nhiều màn hình cho đến khi bạn kết thúc bài thi.",
  "skillCertify-proctoring-face-voice-recording-no-detect-title": "Không tìm thấy camera hoặc micrô",
  "skillCertify-proctoring-face-voice-recording-no-detect-description": "Tính năng giám sát đã bị gián đoạn nên không thể tiếp tục.\nVui lòng quay lại màn hình bắt đầu, thiết lập lại camera/micrô và tiếp tục.",
  "skillCertify-proctoring-face-voice-recording-no-detect-button": "Quay lại màn hình bắt đầu",
  "hands-on-environment-setup-loading": "Đang thiết lập môi trường thực hành.",
  "hands-on-environment-setup-loading-title": "Vui lòng chờ thêm một chút.",
  "hands-on-environment-setup-completed": "Môi trường thực hành đã sẵn sàng.",
  "hands-on-environment-setup-completed-info": "Hãy nhấp vào nút bên dưới để tiếp tục thực hành.",
  "hands-on-environment-setup-completed-button": "Tiếp tục Thực hành",
  "hands-on-environment-setup-failed": "Thiết lập môi trường thực hành không thành công.",
  "hands-on-environment-setup-failed-info": "Vui lòng nhấn nút bên dưới để thử lại.",
  "hands-on-environment-setup-failed-button": "Thiết lập lại môi trường thực hành",
  "hands-on-environment-setup-description": "Việc thiết lập môi trường thực hành có thể mất {time}.",
  "hands-on-environment-setup-description-time": "khoảng {time} phút",
  "embed-provisioning-phase-queued": "Đang chờ tài nguyên khả dụng…",
  "embed-provisioning-phase-launching": "Đang khởi động môi trường của bạn…",
  "embed-provisioning-expired-info": "Quá trình này lâu hơn dự kiến. Vui lòng thử thiết lập lại.",
  "embed-provisioning-still-preparing": "Môi trường vẫn đang được chuẩn bị. Bạn có thể tiếp tục chờ hoặc thử lại.",
  "learning-run-code-and-save": "Chạy Code và Lưu",
  "learning-rerun-and-save": "Chạy lại code và Lưu",
  "learning-saved": "Đã lưu.",
  "learning-save-failed": "Lưu thất bại.",
  "skillCertify-end-time-info-title": "Bài đánh giá sẽ kết thúc sau {minutes} phút\nVui lòng kiểm tra lại xem bạn đã nộp tất cả các câu trả lời chưa",
  "skillCertify-end-time-info-description": "Nếu còn câu trả lời nào chưa được nộp, vui lòng nộp câu trả lời tương ứng.",
  "skillCertify-assessment-finish-title": "Bài đánh giá đã kết thúc",
  "skillCertify-assessment-finish-description": "Thời gian làm bài đã kết thúc.\nCảm ơn bạn đã tham gia đánh giá.",
  "learning-fail-message": "Chúng tôi không thể nộp câu trả lời của bạn do lỗi tạm thời.",
  "learning-fail-message-retry": "Vui lòng thử lại.",
  "skillCertify-assessment-completed-title": "Các câu trả lời của bạn đã được gửi tới quản trị viên",
  "skillCertify-assessment-completed-description": "Hoàn thiện hồ sơ để làm nổi bật kinh nghiệm và kỹ năng của bạn.",
  "skillCertify-assessment-completed-go-profile": "Đi đến Hồ sơ",
  "skillCertify-load-template": "Tải Mẫu",
  "skillCertify-template": "Mẫu",
  "skillCertify-template-none-save-data": "Chưa có mẫu nào được lưu.",
  "common-apply": "Áp dụng",
  "skillCertify-template-load-title": "Bạn có muốn tải mẫu này không?",
  "skillCertify-template-load-info": "Các track đã được thiết lập trước đó sẽ bị xóa và thay thế bằng các track từ mẫu đã chọn.",
  "skillCertify-template-load-success": "Mẫu đã được áp dụng.",
  "skillCertify-save-template": "Lưu dưới dạng mẫu",
  "skillCertify-template-save-title": "Bạn có muốn lưu các track này dưới dạng mẫu không?",
  "skillCertify-template-save-info-1": "Mẫu đã lưu có thể được sử dụng {element}",
  "skillCertify-template-save-info-2": "khi tạo đánh giá mới hoặc sửa bài đánh giá.",
  "skillCertify-template-name-placeholder": "Điền tên mẫu.",
  "skillCertify-error-template-name": "Tên mẫu phải có độ dài từ 1 đến 30 ký tự.",
  "skillCertify-template-save-success": "Mẫu đã được lưu thành công.",
  "skillCertify-template-save-fail": "Chúng tôi không thể lưu mẫu này.\nVui lòng thử lại.",
  "skillCertify-template-management": "Quản lý mẫu",
  "skillCertify-search-template-name-placeholder": "Tìm kiếm bằng tên mẫu",
  "skillCertify-template-edit-title": "Bạn có muốn chỉnh sửa tên mẫu không?",
  "skillCertify-template-edit-success": "Tên mẫu đã được chỉnh sửa.",
  "skillCertify-template-edit-fail": "Chúng tôi không thể chỉnh sửa tên mẫu.\nVui lòng thử lại.",
  "skillCertify-template-delete-title": "Bạn có chắc chắn muốn xóa mẫu này không?",
  "skillCertify-template-delete-success": "Mẫu đã được xóa thành công.",
  "skillCertify-template-delete-fail": "Chúng tôi không thể xóa mẫu.\nVui lòng thử lại.",
  "skillCertify-caution-multiple-monitor-title": "Kiểm tra cài đặt màn hình",
  "skillCertify-caution-multiple-monitor-description": "Việc sử dụng cùng lúc nhiều màn hình được coi là hành vi gian lận.\nNếu nhiều màn hình đang được sử dụng, hãy ngắt kết nối.",
  "skillCertify-caution-multiple-monitor-enable": "Hiện tại đang không kết nối với nhiều màn hình",
  "skillCertify-caution-multiple-monitor-disable-1": "Đang được kết nối với nhiều màn hình",
  "skillCertify-caution-multiple-monitor-disable-2": "(Cần ngắt kết nối ngay)",
  "skillCertify-caution-recording-title": "Vui lòng đồng ý việc ghi hình",
  "skillCertify-caution-recording-description-basic": "Để ngăn chặn hành vi gian lận, màn hình của bạn sẽ được ghi hình.\nVideo được lưu trữ an toàn và sẽ bị xóa vĩnh viễn sau 30 ngày.",
  "skillCertify-caution-recording-agree-basic": "Tôi đồng ý việc ghi màn hình.",
  "skillCertify-caution-recording-description": "Để ngăn chặn hành vi gian lận, màn hình và khuôn mặt/giọng nói của bạn sẽ được ghi hình.\nVideo được lưu trữ an toàn và sẽ bị xóa vĩnh viễn sau 30 ngày.",
  "skillCertify-caution-recording-agree": "Tôi đồng ý việc ghi hình màn hình và khuôn mặt/giọng nói.",
  "skillCertify-install-proctoring-program-title": "Vui lòng cài đặt Proctive",
  "skillCertify-install-proctoring-program-description": "Để tiếp tục, bạn cần cài đặt chương trình giám sát.\nVui lòng cài đặt bằng liên kết dưới đây.",
  "skillCertify-install-proctoring-program-description-bold": "Sau khi cài đặt, hãy đóng cửa sổ này và thử lại.",
  "skillCertify-update-proctoring-program-title": "Vui lòng cập nhật Proctive",
  "skillCertify-update-proctoring-program-description": "Để tiếp tục, bạn cần cập nhật chương trình giám sát.\nVui lòng cập nhật bằng liên kết dưới đây.",
  "skillCertify-basic-proctoring-recording-fail-title": "Quá trình ghi hình đang gặp sự cố",
  "skillCertify-basic-proctoring-recording-fail-description": "Không thể tiếp tục bài đánh giá do quá trình ghi hình không hoạt động bình thường.\nVui lòng thử lại, và nếu vấn đề vẫn tiếp diễn, hãy liên hệ với {email} để được hỗ trợ.",
  "skillCertify-proctoring-recording-fail-title": "Quá trình ghi hình đang gặp sự cố\nVui lòng kiểm tra các mục sau và khởi động lại Proctive",
  "skillCertify-proctoring-recording-fail-description": "Vui lòng kiểm tra quyền truy cập và trạng thái kết nối của camera và micrô.",
  "skillCertify-proctoring-face-voice-recording-set-up-title": "Vui lòng thiết lập camera và micrô",
  "skillCertify-proctoring-face-voice-recording-set-up-camera": "Camera",
  "skillCertify-proctoring-face-voice-recording-set-up-microphone": "Micrô",
  "skillCertify-proctoring-face-voice-recording-set-up-retry": "Thử lại",
  "skillCertify-proctoring-face-voice-recording-set-up-retry-description": "Kiểm tra lại kết nối camera và micrô.",
  "skillCertify-proctoring-face-voice-recording-set-up-fail-title": "Kết nối camera hoặc micrô không thành công",
  "skillCertify-proctoring-face-voice-recording-set-up-fail-description": "Vui lòng kiểm tra quyền và trạng thái kết nối của camera và micrô.",
  "skillCertify-proctoring-screen-record-title": "Hãy chia sẻ toàn bộ màn hình của bạn",
  "skillCertify-proctoring-full-screen-error": "Để tiếp tục phần đánh giá, bạn phải chia sẻ **toàn bộ màn hình**.",
  "skillCertify-proctoring-entire-screen-recording-no-access-title": "Không thể bắt đầu ghi hình màn hình\nVui lòng kiểm tra các nội dung sau",
  "skillCertify-proctoring-entire-screen-recording-no-access-description-1": "Đảm bảo rằng quyền ghi màn hình đã được cấp.",
  "skillCertify-proctoring-entire-screen-recording-no-access-description-2": "Đảm bảo không có phần mềm nào đang chặn tính năng chụp hoặc ghi màn hình đang chạy.",
  "skillCertify-proctoring-entire-screen-recording-no-access-description-3": "Và nếu vấn đề vẫn tiếp diễn, hãy liên hệ với {email} để được hỗ trợ.",
  "skillCertify-aws-label": "AWS",
  "skillCertify-web-ide-label": "Web IDE",
  "skillCertify-prompt-label": "Prompt",
  "skillCertify-agent-prompt-label": "Agent Prompt",
  "skillCertify-command-multiple-choice-label": "Lệnh & Trắc nghiệm",
  "skillCertify-command-label": "Lệnh",
  "skillCertify-code-no-run-code-label": "Thực hành code (không chạy)",
  "skillCertify-command-short-answer-label": "Lệnh & Tự luận ngắn",
  "skillCertify-code-label": "Thực hành code",
  "skillCertify-multiple-files-code-label": "Thực hành code với nhiều tệp",
  "skillCertify-jupyter-notebook-label": "Jupyter Notebook",
  "skillCertify-coding-agent-label": "Coding Agent",
  "skillCertify-take-assessment-description": "Tổng quan về tất cả các bài đánh giá đã được mời và các đánh giá mẫu.",
  "skillCertify-sample-information-title": "Vui lòng kiểm tra thông tin trước khi bắt đầu bài đánh giá mẫu",
  "skillCertify-sample-information-new-description-1": "Bài đánh giá mẫu là bài đánh giá để bạn trải nghiệm trước tính năng giám sát hoặc các loại câu hỏi, và đáp án đúng cũng như kết quả sẽ không được cung cấp.",
  "skillCertify-sample-information-new-description-2": "Các bản ghi hình và nhật ký hành động phát sinh từ tính năng giám sát sẽ không được lưu và cũng sẽ không được báo cáo cho quản trị viên.",
  "skillCertify-sample-information-new-description-3": "Bài đánh giá mẫu thực hành code có thể được cung cấp bằng ngôn ngữ lập trình khác với bài đánh giá thực tế.",
  "skillCertify-sample-information-new-description-4": "Bạn có thể trải nghiệm bài đánh giá mẫu trước khi tham gia đánh giá được mời. (Tính năng này sẽ không khả dụng sau khi bài đánh giá được mời kết thúc)",
  "skillCertify-sample-unavailable-description": "Hiện tại bạn không thể trải nghiệm bài đánh giá mẫu.\nBạn có thể trải nghiệm khi được mời tham gia một bài đánh giá sắp diễn ra hoặc đang diễn ra.",
  "skillCertify-sample-token-limit-info": "Bài đánh giá này có giới hạn mức sử dụng token, vì vậy việc tạo phản hồi sẽ dừng lại khi đạt đến giới hạn.",
  "skillCertify-sample-assessment-completed-title": "Bạn đã hoàn thành bài đánh giá mẫu",
  "skillCertify-sample-assessment-completed-description": "Làm lại hoặc trải nghiệm một bài đánh giá mẫu khác.",
  "skillCertify-sample-assessment-completed-try-sample-assessment": "Trải nghiệm bài đánh giá mẫu",
  "skillCertify-command-question-type": "Thể loại câu hỏi",
  "skillCertify-command-basic-proctoring-label": "Giám sát cơ bản",
  "skillCertify-command-advanced-proctoring-label": "Giám sát nâng cao",
  "skillCertify-proctoring-screen-record-description-3": "Các video được tạo sẽ bị xóa vĩnh viễn sau 30 ngày.",
  "common-retry": "Thử lại",
  "assessment-provision-failed": "Không thể chuẩn bị môi trường thực hành.\nVui lòng thử lại hoặc liên hệ hỗ trợ nếu sự cố vẫn tiếp diễn.",
  "skillCertify-advanced-proctoring-restriction-info": "Giám sát nâng cao khả dụng trên các gói Pro và Enterprise.",
  "skillCertify-advanced-proctoring-restriction-info-2": "Nếu bạn muốn sử dụng Giám sát nâng cao, vui lòng liên hệ với người quản lý chuyên trách.",
  "skillCertify-report-language-tip": "Báo cáo đánh giá và báo cáo ứng viên sẽ được tạo bằng ngôn ngữ đã chọn.",
  "skillCertify-report-language-info-1": "Gói Basic chỉ cho phép chọn 1 ngôn ngữ.",
  "skillCertify-report-language-info-2": "Có thể chọn thêm ngôn ngữ ở gói Pro và Enterprise.",
  "skillCertify-creation-restriction-info-1-title": "Không thể tạo bài đánh giá do không có gói đăng ký nào đang hoạt động",
  "skillCertify-creation-restriction-info-2-title": "Không thể tạo bài đánh giá do gói đăng ký đã kết thúc",
  "credit-certify-creation-limit-description-1": "Nếu bạn cần thêm credit, bạn có thể mua thêm trong {linkDom}.",
  "credit-certify-creation-limit-description-2": "Quản lý Credit",
  "credit-certify-creation-limit-button": "Đi đến Quản lý credit",
  "credit-certify-invitation-restriction-info-title": "Không thể mời ứng viên do gói đăng ký đã kết thúc",
  "skillCertify-assessment-time-added": "Đã thêm {minutes} phút",
  "skillCertify-assessment-time-extension-history": "Lịch sử thêm thời gian",
  "skillCertify-assessment-total-added-time": "Tổng thời gian đã thêm",
  "skillCertify-assessment-time-added-toast": "Thời gian làm bài đã được cộng thêm {minutes} phút.",
  "skillCertify-core-label": "Core",
  "skillCertify-e2e-label": "E2E",
  "skillCertify-aI-fluent-label": "AI Fluent",
  "skillCertify-plan-restriction-info": "Chỉ dành cho gói Pro / Enterprise",
  "skillCertify-calculation-basis": "Cơ sở tính toán",
  "skillCertify-credit": "Credit",
  "skillCertify-track-count": "{count} Track | {count} Tracks",
  "skillCertify-credit-count": "{count} Credit",
  "skillCertify-credit-info": "Khi mời 1 ứng viên, sẽ sử dụng",
  "skillCertify-credit-info-1": "{count}",
  "skillCertify-credit-info-2": "credit.",
  "skillCertify-select-disabled-info-1": "Vì đã chọn track Core hoặc E2E nên không thể chọn track AI Fluent.",
  "skillCertify-select-disabled-info-1-1": "Track AI Fluent được cấu hình để sử dụng độc lập.",
  "skillCertify-select-disabled-info-2": "Vì đã chọn track AI Fluent nên không thể chọn các track khác.",
  "skillCertify-select-disabled-info-2-1": "Track AI Fluent được cấu hình để sử dụng độc lập.",
  "skillCertify-tracks-settings-disabled-info-1": "Bạn không thể thay đổi track sau khi đã mời ứng viên.",
  "skillCertify-tracks-settings-disabled-info-2": "Bạn có thể chỉnh sửa thông tin cơ bản và tính năng giám sát ở bước tiếp theo, và có thể thay đổi lại track nếu xóa toàn bộ ứng viên đã được mời.",
  "skillCertify-invite-candidates-candidate-count": "Mời {count} ứng viên",
  "skillCertify-invite-candidates-credit-count": "Sẽ sử dụng {count} credit",
  "skillCertify-invite-candidates-credit-count-per-candidate": "Sẽ sử dụng {count} credit cho mỗi ứng viên",
  "skillCertify-invite-candidates-estimated-remaining": "Số credit dự kiến còn lại sau khi mời ứng viên",
  "skillCertify-invite-candidates-insufficient-credits": "Credit còn thiếu",
  "skillCertify-calculation-basis-track-count": "Số lượng track đã thiết lập",
  "skillCertify-calculation-basis-credit-count": "Số lượng credit sẽ bị trừ",
  "webcam-recording-active": "Đang ghi hình webcam",
  "SkillCertify-duplicate-session-warning-title": "Bài đánh giá đang được tiến hành trên một màn hình khác",
  "SkillCertify-duplicate-session-warning-description": "Bạn không thể tiếp tục bài đánh giá trên màn hình hiện tại.",
  "skillCertify-tracks-setup-method": "Phương thức thiết lập Track",
  "skillCertify-tracks-setup-manual": "Thiết lập thủ công",
  "skillCertify-tracks-select-manually": "Tự lựa chọn Track",
  "skillCertify-tracks-ai-recommendation": "Đề xuất bằng AI",
  "skillCertify-tracks-get-recommendation": "Nhận đề xuất Track",
  "skillCertify-tracks-setup-method-change-title": "Bạn có muốn thay đổi phương thức thiết lập Track không?",
  "skillCertify-tracks-setup-method-change-description": "Các Track hiện tại sẽ được cài đặt lại.",
  "skillCertify-tracks-recommendation-input-guide": "Vui lòng nhập thông tin cần thiết để nhận đề xuất Track.",
  "skillCertify-tracks-recommendation-credit-info": "Mỗi lần nhận đề xuất bằng AI sẽ tương ứng với một credit.",
  "skillCertify-tracks-recommendation-monthly-limit-basic": "5 lần/tháng",
  "skillCertify-tracks-recommendation-monthly-limit-pro": "20 lần/tháng",
  "skillCertify-tracks-recommendation-job-role": "Vị trí công việc",
  "skillCertify-tracks-recommendation-job-role-placeholder": "Vui lòng chọn vị trí công việc.",
  "skillCertify-tracks-recommendation-job-role-backend": "Backend Developer",
  "skillCertify-tracks-recommendation-job-role-frontend": "Frontend Developer",
  "skillCertify-tracks-recommendation-job-role-ai-ml": "AI/ML Engineer",
  "skillCertify-tracks-recommendation-work-experience-placeholder": "Vui lòng chọn kinh nghiệm làm việc của bạn.",
  "skillCertify-tracks-recommendation-work-experience-entry": "Dưới 2 năm",
  "skillCertify-tracks-recommendation-work-experience-mid": "3-5 năm",
  "skillCertify-tracks-recommendation-work-experience-senior": "Trên 6 năm",
  "skillCertify-tracks-recommendation-keywords": "Bản mô tả công việc hoặc từ khóa kỹ năng",
  "skillCertify-tracks-recommendation-keywords-placeholder": "Vui lòng nhập mô tả công việc hoặc từ khóa kỹ năng.\nVí dụ: Python, Java, AWS,...",
  "skillCertify-tracks-recommendation-submit": "Nhận đề xuất",
  "skillCertify-tracks-recommendation-limit-reached": "Bạn đã sử dụng hết số lượt đề xuất bằng AI.\nBạn có thể sử dụng lại vào lần gia hạn tiếp theo.",
  "skillCertify-tracks-recommendation-fail": "Chúng tôi không thể nhận đề xuất do lỗi tạm thời.\nVui lòng thử lại.",
  "skillCertify-tracks-recommendation-loading": "AI đang tìm các Track phù hợp.\nVui lòng đợi trong giây lát.",
  "skillCertify-tracks-recommendation-no-result": "Chúng tôi không tìm thấy Track nào phù hợp với những điều kiện bạn đã nhập.\nVui lòng chỉnh sửa thông tin và thử lại.",
  "skillCertify-tracks-recommendation-edit-info": "Chỉnh sửa thông tin",
  "skillCertify-tracks-recommendation-entered-info": "Thông tin đã nhập",
  "skillCertify-tracks-recommendation-reason": "Lý do đề xuất",
  "skillCertify-tracks-recommendation-show-more": "Xem thêm",
  "skillCertify-tracks-recommendation-show-less": "Thu gọn",
  "skillCertify-tracks-recommendation-reason-fail": "Chúng tôi không thể tải lý do đề xuất.",
  "skillCertify-tracks-recommendation-result": "Track được đề xuất",
  "skillCertify-tracks-recommendation-result-guide": "Vui lòng chọn Track muốn thiết lập trong số các Track được đề xuất bên dưới.",
  "skillCertify-tracks-recommendation-matching-basis": "Từ khóa phù hợp",
  "skillCertify-tracks-recommendation-no-desired-track": "Không có Track nào phù hợp?",
  "skillCertify-tracks-recommendation-edit-info-title": "Bạn có muốn chỉnh sửa thông tin đã nhập không?",
  "skillCertify-tracks-recommendation-edit-info-description": "Các Track được đề xuất hiện tại sẽ được cài đặt lại.",
  "skillCertify-tracks-recommendation-apply-selected": "Áp dụng Track đã chọn",
  "skillCertify-tracks-recommendation-apply-success": "Các Track được đề xuất đã được áp dụng.",
  "skillCertify-current-question": "Câu hỏi hiện tại",
  "skillCertify-answer-status-not-submitted": "Chưa nộp",
  "skillCertify-answer-status-submitted": "Đã nộp",
  "skillCertify-answer-status-resubmit-required": "Cần nộp lại",
  "skillCertify-submit-answer-for-grading": "Vui lòng hoàn tất việc nộp câu trả lời để được chấm điểm.",
  "skillCertify-away-with-out-title": "Câu trả lời cho câu hỏi hiện tại vẫn chưa được nộp\nBạn có muốn nộp câu trả lời không?",
  "skillCertify-away-with-out-description-1": "Bạn nên nộp câu trả lời trước khi thoát ra.",
  "skillCertify-away-with-out-description-2": "Nếu bạn có bất kỳ thay đổi bổ sung nào sau khi nộp câu trả lời, bạn vẫn có thể nộp lại.",
  "skillCertify-away-with-out-leave": "Thoát và không nộp",
  "skillCertify-locale-change-with-out-submitting-description": "Bạn nên nộp câu trả lời trước khi thay đổi ngôn ngữ.",
  "skillCertify-locale-change-with-out-submitting": "Đổi ngôn ngữ và không nộp",
  "skillCertify-submit-answer-require-run-code-and-save": "Vui lòng nhấn chọn Chạy Code và Lưu trước khi nộp bài.",
  "skillCertify-question-provides-api-reference": "Câu hỏi này cung cấp {resourcesLink}.",
  "skillCertify-device-block-title": "Bạn chỉ có thể tham gia bài đánh giá trên PC",
  "skillCertify-device-block-description": "Vui lòng truy cập bằng PC và thử lại.\nNếu cần hỗ trợ, vui lòng liên hệ với chúng tôi qua Channel Talk.",
  "skillCertify-environment-check-start-button": "Bắt đầu kiểm tra môi trường thi",
  "skillCertify-environment-check-title": "Vui lòng kiểm tra môi trường thi của bạn",
  "skillCertify-environment-check-description": "Trước khi bắt đầu bài đánh giá, bạn cần kiểm tra xem camera, micrô và tính năng ghi màn hình có hoạt động bình thường hay không.\nThời gian làm bài chỉ bắt đầu tính sau khi bạn hoàn tất việc kiểm tra và bắt đầu bài đánh giá.",
  "skillCertify-environment-check-result-title": "Kết quả kiểm tra",
  "skillCertify-environment-check-status-checking": "Đang kiểm tra...",
  "skillCertify-environment-check-status-ok": "Bình thường",
  "skillCertify-environment-check-status-failed": "Cần kiểm tra",
  "skillCertify-environment-check-has-failed-item": "Có một số mục chưa được xác nhận bình thường.",
  "skillCertify-environment-check-help-button": "Xem cách khắc phục",
  "skillCertify-environment-check-help-title": "Cách khắc phục",
  "skillCertify-environment-check-help-camera-microphone": "Camera/Micrô",
  "skillCertify-environment-check-help-detail-guide": "Xem mục Trợ giúp để biết cách khắc phục chi tiết",
  "skillCertify-environment-check-contact-channel-talk": "Nếu cần hỗ trợ, vui lòng liên hệ với chúng tôi qua Channel Talk.",
  "skillCertify-environment-check-screen-share-guide-title": "Vui lòng kiểm tra tính năng chia sẻ màn hình",
  "skillCertify-environment-check-screen-share-guide-description": "Trước khi bắt đầu bài đánh giá, bạn cần kiểm tra xem tính năng chia sẻ màn hình có hoạt động bình thường hay không.\nVui lòng chia sẻ **toàn bộ màn hình** khi kiểm tra.\nThời gian làm bài chỉ bắt đầu tính sau khi bạn hoàn tất việc kiểm tra và bắt đầu bài đánh giá.",
  "skillCertify-environment-check-screen-share-button": "Kiểm tra tính năng chia sẻ màn hình",
  "skillCertify-environment-check-screen-share-complete-title": "Đã hoàn tất kiểm tra tính năng chia sẻ màn hình",
  "skillCertify-environment-check-screen-share-complete-description": "Để bắt đầu bài đánh giá, hãy nhấn vào nút bên dưới.",
  "skillCertify-environment-check-full-screen-error": "Để kiểm tra tính năng chia sẻ màn hình, bạn phải chia sẻ **toàn bộ màn hình**.",
  "skillCertify-environment-check-cancelled-toast": "Bạn phải hoàn tất việc kiểm tra thì mới có thể bắt đầu bài đánh giá.",
  "skillCertify-environment-check-screen-share-permission-required": "Cần có quyền chia sẻ màn hình\nVui lòng kiểm tra các nội dung sau",
  "skillMonitor-main-description": "Giám sát dữ liệu năng lực được đo lường chính xác của thành viên trong tổ chức và lực lượng lao động bên ngoài, qua đó tận dụng hiệu quả dữ liệu này trong các quyết định như phân công dự án, đào tạo, tuyển dụng và nhiều hơn thế nữa.",
  "skillMonitor-main-sample-title": "Hiện tại, bạn có thể xem dữ liệu mẫu.",
  "skillMonitor-main-sample-description": "Dữ liệu thực tế sẽ được hiển thị khi tạo bài đánh giá.",
  "skillMonitor-main-sample-do-not-again": "Không hiển thị lại",
  "skillMonitor-main-limit-permission-title": "Bạn không có quyền truy cập trang này",
  "skillMonitor-main-limit-permission-description": "Bạn chỉ có thể xem các trang trong phạm vi của tổ chức của bạn.",
  "skillMonitor-assessments-overview": "Tổng quan về đánh giá",
  "skillMonitor-candidates-overview": "Tổng quan về ứng viên",
  "common-total": "Tổng",
  "skillMonitor-closed-assessment-count": "Bài đánh giá đã đóng | Các bài đánh giá đã đóng",
  "skillMonitor-chart-last": "Cuối cùng",
  "skillMonitor-chart-months": "12 tháng",
  "skillMonitor-summary-none-closed-assessment": "Hiện chưa có bài đánh giá nào đã đóng.",
  "skillMonitor-chart-completed-candidates-count": "Số ứng viên đã hoàn thành | Số các ứng viên đã hoàn thành",
  "skillMonitor-summary-none-closed-candidate": "Hiện chưa có ứng viên nào đã hoàn thành.",
  "common-average": "Trung bình",
  "skillMonitor-main-track-level": "Phân bố cấp độ",
  "skillMonitor-chart-none-track-level": "Hiện chưa có dữ liệu về các cấp độ.",
  "skillMonitor-chart-track-level": "Phân bố cấp độ track của các ứng viên",
  "skillCertify-candidate": "Ứng viên | Các ứng viên",
  "skillMonitor-main-assessment-list": "Đánh giá",
  "skillMonitor-main-assessment-list-more": "Xem tất cả các bài đánh giá",
  "skillMonitor-completed-candidate": "Các ứng viên đã hoàn thành",
  "skillMonitor-main-candidate-list-more": "Xem tất cả các ứng viên",
  "skillMonitor-main-assessment-list-banner": "Bạn có thể kiểm tra các bài đánh giá được tạo bởi tổ chức của bạn.",
  "skillMonitor-candidate-list-banner": "Bạn có thể kiểm tra những ứng viên đã hoàn thành các bài đánh giá.",
  "skillMonitor-action-date": "Ngày xảy ra hành động",
  "skillMonitor-action-screen-switch": "Chuyển màn hình",
  "skillMonitor-action-shortcut": "Phím tắt trái phép",
  "skillMonitor-action-multi-monitor": "Kết nối cùng lúc nhiều màn hình",
  "skillMonitor-action-copy": "Sao chép",
  "skillMonitor-action-cut": "Cắt",
  "skillMonitor-action-paste": "Dán",
  "skillMonitor-action-type": "Loại hành động",
  "skillMonitor-filter-by": "Lọc theo",
  "skillMonitor-track-info": "Thông tin Track",
  "skillMonitor-assessment-submission": "Câu trả lời đã nộp",
  "skillMonitor-assessment-partially-answer": "Câu trả lời đúng một phần",
  "skillMonitor-assessment-incorrect-answer": "Câu trả lời sai",
  "skillMonitor-assessment-incorrect": "Sai",
  "skillMonitor-assessment-answerer": "Câu trả lời của {userName}",
  "skillMonitor-assessment-answerer-none": "Chưa có câu trả lời nào đã được nộp.",
  "skillMonitor-analysis-title": "Chỉ số của {userName}",
  "skillMonitor-analysis-metric-name": "Danh mục phân tích tĩnh",
  "common-result": "Kết quả",
  "skillMonitor-analysis-severity": "Mức độ nghiêm trọng",
  "skillMonitor-analysis-metric-tooltip-DUPLICATIONS": "Xác định các đoạn code bị trùng lặp.",
  "skillMonitor-analysis-metric-tooltip-CYCLOMATIC_COMPLEXITY": "Chỉ số đánh giá độ phức tạp của code, được tính bằng số lượng đường dẫn logic trong chương trình. Số lượng câu lệnh điều kiện hoặc vòng lặp càng nhiều thì độ phức tạp càng cao.",
  "skillMonitor-analysis-metric-tooltip-BUGS": "Chỉ ra các lỗi tiềm tàng có trong code.",
  "skillMonitor-analysis-metric-tooltip-CODING_STYLE": "Kiểm tra xem code có tuân thủ phong cách và tiêu chuẩn lập trình nhất quán hay không.",
  "skillMonitor-analysis-code-smell": "Code Smell",
  "skillMonitor-analysis-code-smell-long-method": "Một phương thức quá dài, đảm nhiệm quá nhiều công việc cùng lúc trong một phương thức.",
  "skillMonitor-analysis-code-smell-large-class": "Một lớp có quá nhiều thuộc tính và phương thức, đảm nhiệm quá nhiều trách nhiệm.",
  "skillMonitor-analysis-code-smell-primitive-obsession": "Lạm dụng các kiểu dữ liệu cơ bản (ví dụ: int, string), khiến mô hình miền không rõ ràng.",
  "skillMonitor-analysis-code-smell-long-parameter-list": "Một phương thức có quá nhiều tham số, gây khó khăn trong việc sử dụng và bảo trì.",
  "skillMonitor-analysis-code-smell-data-clumps": "Các nhóm dữ liệu thường xuyên xuất hiện cùng nhau trong code.",
  "skillMonitor-analysis-code-smell-alternative-classes-with-different-interfaces": "Các lớp có chức năng tương tự nhưng sử dụng giao diện khác nhau.",
  "skillMonitor-analysis-code-smell-refused-bequest": "Lớp con không sử dụng các phương thức hoặc thuộc tính được kế thừa từ lớp cha.",
  "skillMonitor-analysis-code-smell-switch-statements": "Các câu lệnh switch hoặc if-else được lặp lại nhiều lần hoặc quá phức tạp.",
  "skillMonitor-analysis-code-smell-temporary-field": "Thuộc tính của lớp chỉ được sử dụng trong một số trường hợp cụ thể, làm giảm khả năng đọc và bảo trì mã nguồn.",
  "skillMonitor-analysis-code-smell-divergent-change": "Một lớp thường xuyên thay đổi vì nhiều lý do khác nhau.",
  "skillMonitor-analysis-code-smell-parallel-inheritance-hierarchies": "Một hệ thống các lớp phụ thuộc nhiều vào một hệ thống lớp khác theo cách song song.",
  "skillMonitor-analysis-code-smell-shotgun-surgery": "Một thay đổi nhỏ ảnh hưởng đến nhiều lớp khác nhau trong dự án dẫn đến việc phải chỉnh sửa ở nhiều nơi trong dự án.",
  "skillMonitor-analysis-code-smell-comments": "Code không thể tự giải thích mà cần quá nhiều chú thích hoặc ý định chỉ có thể hiểu thông qua chú thích.",
  "skillMonitor-analysis-code-smell-duplicate-code": "Đoạn code giống nhau được lặp lại ở nhiều vị trí trong dự án.",
  "skillMonitor-analysis-code-smell-data-class": "Lớp chỉ chứa các thuộc tính và phương thức getter/setter.",
  "skillMonitor-analysis-code-smell-dead-code": "Đoạn code không còn được sử dụng nhưng vẫn tồn tại trong dự án.",
  "skillMonitor-analysis-code-smell-lazy-class": "Lớp có quá ít trách nhiệm, không cần thiết để tồn tại.",
  "skillMonitor-analysis-code-smell-speculative-generality": "Code được tổng quát hóa để sử dụng trong tương lai nhưng hiện tại không cần thiết.",
  "skillMonitor-analysis-code-smell-feature-envy": "Phương thức quan tâm tới dữ liệu của các lớp khác nhiều hơn là dữ liệu của lớp mà nó thuộc về.",
  "skillMonitor-analysis-code-smell-inappropriate-intimacy": "Hai lớp phụ thuộc quá mức vào nhau, truy cập sâu vào nội bộ của nhau.",
  "skillMonitor-analysis-code-smell-incomplete-library-class": "Một lớp trong thư viện được sử dụng thiếu các chức năng cần thiết, gây bất tiện khi sử dụng.",
  "skillMonitor-analysis-code-smell-message-chains": "Chuỗi các lời gọi phương thức được liên tiếp liên kết với nhau thành một chuỗi quá dài.",
  "skillMonitor-assessment-candidates-result": "Kết quả ứng viên",
  "skillMonitor-assessment-report-guide": "Hướng dẫn giải thích báo cáo",
  "skillMonitor-assessment-summary-title": "Tổng quan về Đánh giá",
  "skillMonitor-track-summary-title-change": "Tổng quan về Track",
  "skillMonitor-skill-summary-title": "Tổng quan về Kỹ năng",
  "skillMonitor-assessment-summary-candidates-rate": "Tỷ lệ hoàn thành",
  "skillMonitor-assessment-summary-skill-rate": "Tỷ lệ đạt kỹ năng",
  "skillMonitor-assessment-summary-result": "Tóm tắt kết quả đánh giá",
  "skillMonitor-assessment-summary-track-table-title": "Mô tả theo Track",
  "skillMonitor-track-summary-result": "Tóm tắt kết quả Track",
  "skillMonitor-track-summary-score-info": "Thông tin điểm số của Track",
  "skillMonitor-track-summary-min": "Thấp nhất",
  "skillMonitor-track-summary-mid": "Trung bình",
  "skillMonitor-track-summary-max": "Cao nhất",
  "skillMonitor-track-summary-highest": "Cao nhất",
  "skillMonitor-track-summary-lowest": "Thấp nhất",
  "skillMonitor-track-summary-score-highest-info": "Đây là track có điểm trung bình cao nhất.",
  "skillMonitor-track-summary-score-lowest-info": "Đây là track có điểm trung bình thấp nhất.",
  "skillMonitor-track-summary-high": "Cao",
  "skillMonitor-track-summary-low": "Thấp",
  "skillMonitor-track-summary-table-standard-deviation": "Độ lệch chuẩn",
  "skillMonitor-track-summary-table-average-time-taken": "Thời gian trung bình đã sử dụng",
  "skillMonitor-assessment-candidates-chart-track-score": "Phân bố điểm số theo từng track của các ứng viên tham gia đánh giá",
  "skillMonitor-all-candidates-based-info-top": "Ứng viên đứng đầu",
  "skillMonitor-all-candidates-based-info-bottom": "Ứng viên đứng cuối",
  "skillMonitor-assessment-candidates-chart-track-score-range": "Khoảng điểm",
  "skillMonitor-assessment-candidates-chart-track-time-taken-range": "Khoảng thời gian (phút)",
  "skillMonitor-assessment-candidates-chart-track-skill-rate-range": "Phạm vi tỷ lệ đạt kỹ năng (%)",
  "skillMonitor-assessment-candidates-chart-percentage": "Tỷ lệ ứng viên đánh giá",
  "skillMonitor-assessment-candidates-chart-button": "Xem ứng viên theo khoảng",
  "skillMonitor-assessment-candidates-chart-track-time-taken": "Phân bố thời gian làm bài đánh giá của các ứng viên theo Track",
  "skillMonitor-track-summary-skill-acquisition-rate-and-time-taken-info": "Thông tin tỷ lệ đạt kỹ năng và thời gian đã sử dụng của Track",
  "skillMonitor-track-summary-skill-rate-highest-info": "Đây là track có tỷ lệ đạt kỹ năng trung bình cao nhất.",
  "skillMonitor-track-summary-skill-rate-lowest-info": "Đây là track có tỷ lệ đạt kỹ năng trung bình thấp nhất.",
  "skillMonitor-assessment-candidates-chart-track-skill-rate": "Phân bố tỷ lệ đạt kỹ năng của các ứng viên đánh giá theo Track",
  "skillMonitor-track-summary-skill-info": "Thông tin kỹ năng theo Track",
  "skillMonitor-track-summary-skill-acquired": "Đạt",
  "skillMonitor-track-summary-skill-needs-Improvement": "Cần cải thiện",
  "skillMonitor-track-summary-skill-not-acquired": "Chưa đạt",
  "skillMonitor-assessment-candidates-chart-track-skill-level": "Phân bố cấp độ kỹ năng của các ứng viên đánh giá theo Track",
  "skillMonitor-assessment-candidates-chart-track-skill-level-legend": "Cấp độ kỹ năng",
  "skillMonitor-assessment-candidates-chart-track-skill-level-legend-acquired": "Năng lực đạt",
  "skillMonitor-assessment-candidates-chart-track-skill-level-legend-needs-Improvement": "Hiểu khái niệm nhưng cần cải thiện năng lực áp dụng và sử dụng trong thực tế.",
  "skillMonitor-assessment-candidates-chart-track-skill-level-legend-not-acquired": "Năng lực chưa đạt",
  "skillMonitor-assessment-summary-result-none-data": "Chưa có bản tóm tắt kết quả. Bản tóm tắt kết quả sẽ được tạo sau khi bài đánh giá kết thúc.",
  "skillMonitor-candidate-report-unsubmitted-1": "Thí sinh không nộp bài cho hầu hết các hạng mục đánh giá.\nDo đó, không đủ căn cứ để đánh giá một cách khách quan mức độ đáp ứng cũng như độ chi tiết của từng năng lực, dẫn đến việc không thể thực hiện chẩn đoán tổng thể về năng lực.",
  "skillMonitor-candidate-report-unsubmitted-2": "Trong bài đánh giá này, do thí sinh không nộp câu trả lời, nên không thể thực hiện đánh giá đối với năng lực này.",
  "skillMonitor-sort-by": "Sắp xếp theo",
  "skillMonitor-candidates-summary-title": "Tóm tắt ứng viên",
  "skillMonitor-candidates-summary-result": "Tóm tắt kết quả ứng viên",
  "skillMonitor-score-based-info": "Dựa trên điểm",
  "skillMonitor-skill-acquisition-rate-based-info": "Dựa trên tỷ lệ đạt kỹ năng",
  "skillMonitor-candidates-Integrity-concerns-info": "Nghi ngờ ứng viên có dấu hiệu gian lận",
  "skillMonitor-candidates-Integrity-reason": "Lý do",
  "skillMonitor-candidate-action-analysis-result": "Kết quả phân tích hành động",
  "skillMonitor-candidate-report": "Báo cáo ứng viên",
  "skillMonitor-assessment-summary-score-info": "Thông tin điểm số Đánh giá",
  "skillMonitor-summary-table-assessment-average-score": "So với điểm trung bình (ứng viên đánh giá)",
  "skillMonitor-summary-table-assessment-average-none": "Do chỉ có 1 ứng viên, \ndữ liệu so sánh với mức trung bình sẽ không được cung cấp.",
  "skillMonitor-assessment-candidates-chart-assessment-score": "Phân bố điểm số đánh giá của các ứng viên",
  "skillMonitor-assessment-candidates-chart-assessment-time-taken": "Phân bố thời gian làm bài đánh giá của các ứng viên",
  "skillMonitor-assessment-summary-skill-acquisition-rate-and-time-taken-info": "Thông tin tỷ lệ đạt kỹ năng và thời gian làm bài Đánh giá",
  "skillMonitor-summary-table-assessment-average-skill-rate": "So với tỷ lệ đạt kỹ năng trung bình (ứng viên đánh giá)",
  "skillMonitor-assessment-candidates-chart-assessment-skill-rate": "Phân bố tỷ lệ đạt kỹ năng đánh giá của các ứng viên",
  "skillMonitor-assessment-submission-button": "Xem các câu trả lời đã nộp",
  "skillMonitor-track-summary-score-highest-info-2": "Đây là track có điểm cao nhất.",
  "skillMonitor-track-summary-score-lowest-info-2": "Đây là track có điểm thấp nhất.",
  "skillMonitor-track-summary-skill-rate-highest-info-2": "Đây là track có tỷ lệ đạt kỹ năng cao nhất.",
  "skillMonitor-track-summary-skill-rate-lowest-info-2": "Đây là track có tỷ lệ đạt kỹ năng thấp nhất.",
  "skillMonitor-candidate-strength-button": "Xem điểm mạnh",
  "skillMonitor-candidate-areas-for-improvement-button": "Xem các điểm cần cải thiện",
  "skillMonitor-candidate-strength-areas-for-improvement-button": "Xem điểm mạnh và các điểm cần cải thiện",
  "skillMonitor-candidate-strength": "Điểm mạnh",
  "skillMonitor-candidate-areas-for-improvement": "Các điểm cần cải thiện",
  "skillMonitor-candidate-sw-quality-analysis-result": "Kết quả phân tích chất lượng phần mềm (SW)",
  "skillMonitor-candidate-sw-quality-analysis-result-info": "Kết quả phân tích chất lượng phần mềm (SW) chỉ được cung cấp đối với các câu hỏi có thể phân tích.",
  "skillMonitor-candidate-sw-quality-analysis-result-count": "{question} trên {total} Câu hỏi",
  "skillMonitor-candidate-sw-quality-analysis-summary-result": "Tóm tắt kết quả phân tích chất lượng phần mềm (SW)",
  "skillMonitor-candidate-sw-quality-analysis-recommendations-for-improvement": "Đề xuất cải thiện",
  "skillMonitor-static-analysis-metrics-count": "{count} Metric | {count} Metrics",
  "skillMonitor-analysis-primary-file": "Tệp được phân tích",
  "skillMonitor-analysis-pass": "Đạt",
  "skillMonitor-analysis-warning": "Cảnh báo",
  "skillMonitor-analysis-fail": "Không đạt",
  "skillMonitor-analysis-not-applicable": "Chưa tính",
  "skillMonitor-candidate-action-analysis-info": "Thông tin phân tích hành động",
  "skillMonitor-candidates-Integrity-grade": "Mức độ trung thực",
  "skillMonitor-candidates-grade": "Mức độ",
  "skillMonitor-candidates-Integrity-grade-1": "Không có gian lận",
  "skillMonitor-candidates-Integrity-grade-1-description": "Trong quá trình đánh giá, không phát hiện hành động đáng ngờ hay hành vi gian lận nào, và ứng viên đã tuân thủ đầy đủ tất cả các quy tắc.",
  "skillMonitor-candidates-Integrity-grade-2": "Hành vi đáng ngờ mức độ nhẹ",
  "skillMonitor-candidates-Integrity-grade-2-description": "Trong quá trình đánh giá, có một số hành động đáng ngờ được phát hiện, nhưng không có bằng chứng rõ ràng về hành vi gian lận và ứng viên nhìn chung đã tuân thủ quy định.",
  "skillMonitor-candidates-Integrity-grade-3": "Hành vi đáng ngờ",
  "skillMonitor-candidates-Integrity-grade-3-description": "Trong quá trình đánh giá, phát hiện một số hành động đáng ngờ có thể cho thấy gian lận, cần kiểm tra thủ công bổ sung.",
  "skillMonitor-candidates-Integrity-grade-4": "Đã cố gắng gian lận nhưng không thành công",
  "skillMonitor-candidates-Integrity-grade-4-description": "Trong quá trình đánh giá, đã phát hiện bằng chứng rõ ràng về hành vi cố gắng gian lận nhưng không thành công.",
  "skillMonitor-candidates-Integrity-grade-5": "Xác nhận gian lận",
  "skillMonitor-candidates-Integrity-grade-5-description": "Trong quá trình đánh giá, đã xảy ra hành vi gian lận rõ ràng, làm giảm đáng kể độ tin cậy của kết quả kiểm tra.",
  "skillMonitor-report-candidate-action-analysis-clean-default-reason": "Không phát hiện gian lận trong bài đánh giá này.",
  "skillMonitor-candidate-action": "Hành động của ứng viên",
  "skillMonitor-candidate-action-count": "Mục",
  "skillMonitor-candidate-video-delete": "Video đã bị xóa.",
  "skillMonitor-candidate-video-no-save": "Video chưa được lưu.",
  "skillMonitor-candidate-recommended-for-review-label": "Đề xuất kiểm tra lại",
  "skillMonitor-candidate-video-recording-duration-information": "Thông tin thời gian ghi hình",
  "skillMonitor-candidate-video-start": "Bắt đầu",
  "skillMonitor-candidate-video-end": "Kết thúc",
  "skillMonitor-candidate-video-current": "Hiện tại",
  "skillMonitor-candidate-video-no-face-voice-recording": "Không có ghi hình khuôn mặt và ghi âm giọng nói",
  "skillMonitor-candidate-video-no-screen-recording": "Không có ghi màn hình",
  "skillMonitor-candidate-video-no-description": "Khoảng trống ghi hình là phần không có dữ liệu ghi lại, do ứng viên rời khỏi bài thi, lỗi hệ thống hoặc các nguyên nhân tương tự.",
  "skillMonitor-candidate-video-playback-speed": "Tốc độ phát",
  "skillMonitor-candidate-video-view-full-screen": "Xem toàn màn hình",
  "skillMonitor-candidate-video-screen-recording": "Ghi màn hình",
  "skillMonitor-assessment-report-get-by-email": "Nhận báo cáo đánh giá qua Email",
  "skillMonitor-candidate-report-get-by-email": "Nhận báo cáo ứng viên qua Email",
  "skillMonitor-all-candidate-report-get-by-email": "Nhận tất cả báo cáo ứng viên qua Email",
  "skillMonitor-assessment-send-report-title": "Nhập địa chỉ email để nhận báo cáo",
  "skillMonitor-assessment-send-report-description": "Báo cáo sẽ được gửi dưới dạng {pdf} đến địa chỉ email bạn đã nhập và có thể mất một khoảng thời gian.",
  "skillMonitor-assessment-send-report-description-pdf": "PDF",
  "skillMonitor-assessment-send-report-description-zip": "ZIP",
  "skillMonitor-assessment-send-report-button": "Gửi Báo cáo",
  "skillMonitor-assessment-send-report-success": "Yêu cầu gửi báo cáo đã hoàn tất.",
  "skillMonitor-assessment-send-report-fail": "Chúng tôi không thể hoàn tất yêu cầu gửi báo cáo.\nVui lòng thử lại.",
  "home-event-title": "Sự kiện của Codepresso",
  "home-event-count": "Sự kiện",
  "home-event-type-Webinar": "Webinar",
  "home-event-type-Conference": "Hội nghị",
  "home-event-type-Seminar": "Hội thảo",
  "home-event-type-Workshop": "Workshop",
  "home-event-type-NetworkingEvent": "Sự kiện kết nối",
  "home-event-type-Exhibition": "Triển lãm",
  "home-event-type-LaunchEvent": "Sự kiện ra mắt",
  "home-event-type-Learnathon": "Learnathon",
  "home-event-engage-Online": "ONLINE",
  "home-event-engage-Offline": "OFFLINE",
  "home-event-engage-OnOffline": "ON/OFFLINE",
  "home-event-none": "Chưa có sự kiện nào được đăng ký.",
  "home-event-all": "Tất cả sự kiện",
  "home-event-info": "Thông tin sự kiện",
  "home-event-info-date": "Thời gian diễn ra sự kiện",
  "home-event-info-period": "Thời hạn đăng ký",
  "home-event-info-location": "Địa điểm",
  "home-event-info-language": "Ngôn ngữ",
  "common-share": "Chia sẻ",
  "home-event-register": "Đăng ký",
  "home-event-speakers": "Diễn giả",
  "home-blog-title": "Codepresso Blog",
  "home-blog-count": "Bài viết",
  "home-blog-none": "Chưa có bài viết nào được đăng ký.",
  "home-blog-all-post": "Tất cả các bài blog",
  "home-blog-author": "Viết bởi",
  "home-blog-about-codepresso": "Về Codepresso",
  "home-blog-about-codepresso-description": "Codepresso cung cấp nền tảng HR SaasS nhằm giúp các tổ chức đánh giá một cách định lượng các kỹ năng của lập trình viên và thúc đẩy việc quản lý nhân tài về IT dựa trên năng lực thực tế. Với Codepresso, các tổ chức có thể kiểm tra, đánh giá và tuyển dụng nhân lực về IT một cách dễ dàng, đồng thời cung cấp các nội dung học tập nâng cao/ tái đào tạo phù hợp cho từng cá nhân. Thông qua quá trình này, mọi dữ liệu về năng lực thực tế của các lập trình viên thu thập được sẽ cho phép các tổ chức đưa ra quyết định dựa trên dữ liệu cụ thể.",
  "home-blog-about-codepresso-learn-more": "Tìm hiểu thêm về Codepresso",
  "home-news-title": "Tin tức của Codepresso",
  "home-news-count": "Tin tức",
  "home-news-none": "Chưa có tin mới nào.",
  "home-news-topic": "Tin tức",
  "dashboard-my-profile": "Xem Hồ sơ",
  "account-profile": "Hồ sơ",
  "profile-private-info": "Đây là thông tin riêng tư.",
  "profile-skill-none-data": "Chưa có kỹ năng nào được ghi.",
  "profile-bios-none-data": "Chưa có tiểu sử nào được ghi.",
  "profile-activity-history-none-data": "Chưa có lịch sử hoạt động nào được ghi.",
  "profile-work-experience-none-data": "Chưa có kinh nghiệm làm việc nào được ghi.",
  "profile-education-none-data": "Chưa có thông tin học vấn nào được ghi.",
  "profile-edit": "Chỉnh sửa",
  "profile-image-upload-fail": "Chúng tôi không thể tải ảnh của bạn.\nĐảm bảo rằng file ảnh của bạn ở dạng JPG, JPEG, PNG, hoặc BMP.",
  "profile-change-success": "Đã lưu thay đổi hồ sơ của bạn.",
  "profile-change-fail": "Chúng tôi không thể lưu thay đổi hồ sơ của bạn.\nVui lòng thử lại.",
  "profile-private": "Riêng tư",
  "profile-public": "Công khai",
  "profile-private-change-success": "Thông tin hồ sơ của bạn hiện tại đang ở chế độ riêng tư.",
  "profile-public-change-success": "Thông tin hồ sơ của bạn hiện tại đang ở chế độ công khai.",
  "profile-job-offer": "Thư mời làm việc",
  "profile-job-offer-info": "Bật cài đặt này để nhận các thư mời làm việc.",
  "profile-add": "Thêm",
  "profile-headline": "Tiêu đề",
  "profile-headline-placeholder": "Điền tiêu đề.",
  "profile-headline-error": "Tiêu đề phải chứa không quá 200 ký tự.",
  "profile-personal-info-title": "Thông tin cá nhân",
  "profile-gender": "Giới tính",
  "profile-gender-drop-item-default": "Chọn giới tính",
  "profile-gender-drop-item-male": "Nam",
  "profile-gender-drop-item-female": "Nữ",
  "profile-gender-drop-item-other": "Khác",
  "profile-gender-drop-item-not-say": "Không tiết lộ",
  "profile-phone-number": "Số điện thoại",
  "profile-phone-number-placeholder": "Điền số điện thoại của bạn.",
  "profile-phone-number-error": "Số điện thoại chứa không quá 25 ký tự.",
  "profile-links": "Các liên kết",
  "profile-links-error-linkedIn": "Bạn phải nhập một URL LinkedIn hợp lệ.",
  "profile-links-error-gitHub": "Bạn phải nhập một URL GitHub hợp lệ.",
  "profile-links-add": "Thêm liên kết",
  "profile-links-remove": "Bạn có chắc chắc muốn xóa liên kết này không?",
  "profile-links-remove-success": "Xóa liên kết thành công.",
  "profile-skills": "Các kỹ năng",
  "profile-skills-search-placeholder": "Tìm kiếm bằng tên các kỹ năng",
  "profile-skills-search-none": "Chúng tôi không tìm thấy {skill}? Bạn có muốn thêm kỹ năng này không?",
  "profile-skills-remove": "Bạn có chắc chắc muốn xóa kỹ năng này không?",
  "profile-skills-remove-success": "Kỹ năng này đã được xóa thành công.",
  "profile-about-me": "Giới thiệu bản thân",
  "profile-title": "Tiêu đề",
  "profile-title-placeholder": "Điền tiêu đề.",
  "profile-title-error": "Tiêu đề phải chứa không quá 25 ký tự.",
  "profile-content": "Nội dung",
  "profile-content-placeholder": "Điền nội dung.",
  "profile-content-error": "Nội dung phải chứa không quá 1500 ký tự.",
  "profile-about-me-delete": "Bạn có chắc chắn muốn xóa mục này không?",
  "profile-about-me-delete-success": "Mục này đã được xóa thành công.",
  "profile-about-me-delete-fail": "Chúng tôi không thể xóa mục này.\nVui lòng thử lại.",
  "profile-activity-history": "Lịch sử Hoạt động",
  "profile-view-more": "Xem thêm",
  "profile-view-less": "Rút gọn",
  "profile-work-experience": "Kinh nghiệm làm việc",
  "profile-work-experience-company-name": "Tên công ty",
  "profile-work-experience-company-name-placeholder": "Điền tên công ty.",
  "profile-work-experience-company-name-error": "Tên công ty phải chứa không quá 50 ký tự.",
  "profile-work-experience-job-title": "Tiêu đề công việc",
  "profile-work-experience-job-title-placeholder": "Điền tiêu đề công việc.",
  "profile-work-experience-job-title-error": "Tiêu đề công việc phải chứa không quá 50 ký tự.",
  "profile-work-experience-location": "Vị trí",
  "profile-work-experience-location-placeholder": "Điền vị trí.",
  "profile-work-experience-location-error": "Vị trí phải chứa không quá 150 ký tự.",
  "profile-work-experience-period": "Đang làm việc",
  "common-start-date": "Ngày bắt đầu",
  "common-month": "Tháng",
  "common-year": "Năm",
  "common-end-date": "Ngày kết thúc",
  "profile-period-error": "Ngày kết thúc không thể trước ngày bắt đầu.",
  "profile-work-experience-description-placeholder": "Điền mô tả.",
  "profile-work-experience-description-error": "Phần mô tả phải chứa không quá 1500 ký tự.",
  "profile-work-experience-entry-delete-title": "Bạn có chắc chắn muốn xóa mục này không?",
  "profile-work-experience-entry-delete-success": "Mục này đã được xóa thành công.",
  "profile-work-experience-entry-delete-fail": "Chúng tôi không thể xóa mục này.\nVui lòng thử lại.",
  "profile-present": "Hiện tại",
  "profile-education": "Học vấn",
  "profile-education-school-name": "Tên trường",
  "profile-education-school-name-placeholder": "Điền tên trường.",
  "profile-education-school-name-error": "Tên trường phải chứa không quá 50 ký tự.",
  "profile-education-degree": "Bằng cấp",
  "profile-education-degree-placeholder": "Điền tên bằng cấp.",
  "profile-education-degree-error": "Bằng cấp phải chứa không quá 50 ký tự.",
  "profile-education-major": "Chuyên ngành",
  "profile-education-major-placeholder": "Điền tên chuyên ngành.",
  "profile-education-major-error": "Chuyên ngành phải chứa không quá 50 ký tự.",
  "profile-education-current-studying": "Hiện tại đang học ở đây",
  "profile-education-delete-title": "Bạn có chắc chắn muốn xóa mục này không?",
  "profile-education-delete-success": "Mục này đã được xóa thành công.",
  "profile-education-delete-fail": "Chúng tôi không thể xóa mục này.\nVui lòng thử lại.",
  "profile-access-limit": "Bạn không thể truy cập vào hồ sơ này",
  "profile-access-limit-description": "Không thể xem hồ sơ của thành viên đã xóa tài khoản.",
  "advance-practice-assessment": "Đánh giá Thực hành",
  "learning-assessment-goal": "Mục tiêu của bài đánh giá thực hành",
  "learning-assessment-goal-description": "Chúng tôi muốn biết kinh nghiệm của bạn đối với cấp độ này.",
  "learning-assessment-evaluate": "Bộ câu hỏi",
  "learning-assessment-evaluate-description": "Phần đánh giá thực hành bao gồm các câu hỏi thực hành và câu hỏi trắc nghiệm.",
  "learning-assessment-how-to-complete": "Cách để hoàn thành",
  "learning-assessment-how-to-complete-description": "Bạn cần đạt được mức điểm yêu cầu để vượt qua bài đánh giá thực hành.",
  "common-retake": "Làm lại",
  "learning-progress": "Tiến độ",
  "learning-leave-warning-title": "Bạn có muốn rời khỏi màn hình bài đánh giá không?",
  "learning-leave-warning-description": "Câu trả lời bạn đã nộp có thể sẽ không được lưu lại.",
  "learning-leave": "Rời đi",
  "learning-finished-question": "Câu trả lời của bạn đã được nộp.",
  "learning-assessment-date": "Ngày đánh giá",
  "learning-completed-banner": "Bạn đã hoàn thành bài đánh giá này",
  "learning-completed-success-description": "Bạn đã vượt qua bài đánh giá với mức điểm đạt yêu cầu.\nBây giờ bạn có thể bắt đầu bài đánh giá thực hành cho cấp độ mới hoặc xem lại kết quả của cấp độ đã hoàn thành.",
  "learning-completed-fail-description": "Bạn chưa đạt được mức điểm yêu cầu.\nHãy làm lại để vượt qua bài đánh giá.",
  "skillCertify-view-result": "Xem kết quả",
  "pricing-menu": "Giá",
  "pricing-title": "Gói dành cho đánh giá năng lực kỹ thuật",
  "pricing-content": "Chọn gói phù hợp với nhu cầu của bạn",
  "pricing-monthly": "Hàng tháng",
  "pricing-annual": "Hàng năm",
  "pricing-off": "Giảm {percent}%",
  "pricing-basic": "Basic",
  "pricing-pro": "Pro",
  "pricing-enterprise": "Enterprise",
  "pricing-recommend": "Được đề xuất",
  "pricing-year": "Năm",
  "pricing-custom-pricing": "Giá tùy chỉnh",
  "pricing-basic-report": "Báo cáo cơ bản",
  "pricing-basic-skill-report": "Báo cáo năng lực cơ bản",
  "pricing-report-language-single": "1 ngôn ngữ",
  "pricing-ai-assessment-recommendation-times": "Đề xuất đánh giá tùy chỉnh bằng AI {count} lần/tháng",
  "pricing-report-language-unlimited": "Không giới hạn ngôn ngữ",
  "pricing-administrator-account-plural": "Không giới hạn số lượng quản trị viên của tổ chức",
  "pricing-advanced-report": "Báo cáo chi tiết",
  "pricing-advanced-skill-report": "Báo cáo năng lực chi tiết",
  "pricing-all-skill-assessments": "Tất cả bài đánh giá năng lực",
  "pricing-custom-questions": "Thiết kế câu hỏi tùy chỉnh",
  "pricing-account-manager": "Người quản lý chuyên trách",
  "pricing-ai-assessment-recommendation-unlimited": "Không giới hạn đề xuất đánh giá tùy chỉnh bằng AI",
  "pricing-get-started": "Bắt đầu",
  "pricing-coming-soon": "Sắp ra mắt",
  "pricing-current-plan": "Gói hiện tại",
  "pricing-upgrade": "Nâng cấp",
  "pricing-downgrade": "Hạ cấp",
  "pricing-compare-features-by-plan": "So sánh tính năng theo gói",
  "pricing-feature": "Tính năng",
  "pricing-monthly-basic-assessment-invitation-credits": "Credit cơ bản hàng tháng (Không cộng dồn)",
  "pricing-contract-terms": "Điều khoản hợp đồng",
  "pricing-purchase-additional-credits": "Mua thêm credit",
  "pricing-per-credit": "{price} mỗi credit",
  "pricing-assessment-features": "Tính năng đánh giá",
  "pricing-create-basic-assessment": "Tạo đánh giá cơ bản",
  "pricing-advanced-assessment": "Đánh giá năng lực dự án",
  "pricing-core-assessment": "Đánh giá năng lực thực hành",
  "pricing-ai-agent-assessment": "Đánh giá năng lực ứng dụng AI",
  "pricing-core-assessment-description": "Core là bài đánh giá năng lực cốt lõi trong lĩnh vực CNTT kỹ thuật số, và dùng để chẩn đoán mức độ hiểu biết về mặt kỹ thuật cũng như khả năng vận dụng vào thực tiễn của cá nhân thông qua các câu hỏi tình huống và bài đánh giá thực hành thực tế.",
  "pricing-advanced-assessment-description": "E2E mô phỏng các tác vụ dự án thực tế trong môi trường thực hành, giúp đánh giá toàn diện kỹ năng thực tế của lập trình viên từ thiết kế đến triển khai.",
  "pricing-ai-agent-assessment-description": "AI Fluent kiểm chứng toàn diện từ năng lực ứng dụng AI đến năng lực quản trị AI của cá nhân dựa trên các dự án thực tế, và có thể được dùng để rà soát văn hóa phát triển dựa trên AI của tổ chức và xác định định hướng phát triển năng lực.",
  "pricing-core-assessment-filter-description": "Core là",
  "pricing-core-assessment-filter-description-1": "bài đánh giá năng lực cốt lõi trong lĩnh vực CNTT kỹ thuật số, và dùng để chẩn đoán mức độ hiểu biết về mặt kỹ thuật cũng như khả năng vận dụng vào thực tiễn của cá nhân thông qua các câu hỏi tình huống và bài đánh giá thực hành thực tế.",
  "pricing-advanced-assessment-filter-description": "E2E",
  "pricing-advanced-assessment-filter-description-1": "mô phỏng các tác vụ dự án thực tế trong môi trường thực hành, giúp đánh giá toàn diện kỹ năng thực tế của lập trình viên từ thiết kế đến triển khai.",
  "pricing-ai-agent-assessment-filter-description": "AI Fluent",
  "pricing-ai-agent-assessment-filter-description-2": "kiểm chứng toàn diện từ năng lực ứng dụng AI đến năng lực quản trị AI của cá nhân dựa trên các dự án thực tế, và có thể được dùng để rà soát văn hóa phát triển dựa trên AI của tổ chức và xác định định hướng phát triển năng lực.",
  "pricing-report-language": "Ngôn ngữ báo cáo năng lực",
  "pricing-report-language-count-1": "1",
  "pricing-report-language-count-2": "Không giới hạn",
  "pricing-certificate-provided": "Chứng chỉ",
  "pricing-ai-features": "Tính năng AI",
  "pricing-report": "Báo cáo năng lực",
  "pricing-ai-assessment-recommendation": "Đề xuất đánh giá tùy chỉnh bằng AI",
  "pricing-times-a-month": "{count} lần/tháng",
  "pricing-management-and-support": "Quản lý và Hỗ trợ",
  "pricing-person": "1 Người",
  "pricing-administrator": "Quản trị viên của tổ chức",
  "pricing-ats-integration": "Hệ thống quản lý tuyển dụng (ATS)",
  "pricing-to-be-added": "Sắp ra mắt",
  "pricing-basic-ats-provided": "Cung cấp ATS cơ bản",
  "pricing-custom-integration": "Xây dựng ATS chuyên dụng",
  "pricing-support": "Hỗ trợ",
  "pricing-faq": "Câu hỏi thường gặp",
  "pricing-faq-question-1": "Tôi nên chọn gói nào?",
  "pricing-faq-question-1-answer-1": "Bạn có thể chọn gói phù hợp với mục đích đánh giá và mức độ cần thiết của các tính năng.",
  "pricing-faq-question-1-answer-2": "Gói",
  "pricing-faq-question-1-answer-3": "Phù hợp với",
  "pricing-faq-question-1-answer-4": "Các tổ chức muốn bắt đầu đánh giá năng lực kỹ thuật với giám sát cơ bản và báo cáo năng lực cơ bản",
  "pricing-faq-question-1-answer-5": "Các tổ chức cần các tính năng đánh giá nâng cao như giám sát nâng cao và đánh giá năng lực dự án",
  "pricing-faq-question-1-answer-6": "Các tổ chức cần tất cả bài đánh giá năng lực, xây dựng ATS chuyên dụng và hỗ trợ từ người quản lý chuyên trách",
  "pricing-faq-question-2": "Credit là gì?",
  "pricing-faq-question-2-answer-1": "Credit được sử dụng khi mời ứng viên tham gia đánh giá.",
  "pricing-faq-question-2-answer-2": "Để tiến hành đánh giá, bạn cần credit dựa trên số lượng ứng viên và cấu hình bài đánh giá.",
  "pricing-faq-question-3": "Cần bao nhiêu credit để mời một ứng viên?",
  "pricing-faq-question-3-answer-1": "Đối với đánh giá cơ bản, 1 credit sẽ được sử dụng cho một ứng viên.",
  "pricing-faq-question-3-answer-2": "Tuy nhiên, nếu sử dụng các tính năng đánh giá được nâng cao như đánh giá năng lực dự án, số credit được sử dụng có thể tăng tùy thuộc vào cấu hình bài đánh giá.",
  "pricing-faq-question-4": "Khi nào credit được sử dụng?",
  "pricing-faq-question-4-answer-1": "Khi mời ứng viên tham gia đánh giá, credit sẽ được sử dụng dựa trên số lượng ứng viên và cấu hình bài đánh giá.",
  "pricing-faq-question-4-answer-2": "Nếu ứng viên bị xóa khỏi danh sách trước khi bắt đầu bài đánh giá, credit đã được sử dụng cho ứng viên đó sẽ được hoàn lại.",
  "pricing-faq-question-4-answer-3": "Tuy nhiên, sau khi ứng viên bắt đầu bài đánh giá, credit đã sử dụng sẽ không được hoàn lại.",
  "pricing-faq-question-5": "Điều gì xảy ra khi tôi sử dụng hết credit cơ bản hàng tháng?",
  "pricing-faq-question-5-answer-1": "Nếu đã sử dụng hết credit cơ bản hàng tháng, bạn có thể nạp thêm credit để tiếp tục sử dụng.",
  "pricing-faq-question-5-answer-2": "Chỉ Quản trị viên chính của tổ chức mới có thể nạp thêm credit.",
  "pricing-faq-question-5-answer-3": "Credit đã nạp không có thời hạn sử dụng riêng, nhưng chỉ có thể được nạp và sử dụng khi đang đăng ký sử dụng các gói dịch vụ.",
  "pricing-faq-question-5-answer-4": "Tuy nhiên, gói Enterprise được vận hành theo các điều khoản hợp đồng riêng, vì vậy nếu cần nạp thêm credit, vui lòng liên hệ riêng cho chúng tôi.",
  "pricing-faq-question-6": "Điều gì sẽ xảy ra nếu thanh toán không thành công, ví dụ như do thẻ hết hạn?",
  "pricing-faq-question-6-answer-1": "Nếu thanh toán không thành công, email hướng dẫn sẽ được gửi đến email của Quản trị viên chính của tổ chức.",
  "pricing-faq-question-6-answer-2": "Có thể tự động thử lại thanh toán tối đa 3 lần sau khi thanh toán không thành công.",
  "pricing-faq-question-6-answer-3": "Nếu thanh toán tiếp tục không thành công, hệ thống sẽ ngừng thử lại thanh toán tự động và gói đăng ký của bạn sẽ kết thúc.",
  "pricing-faq-question-7": "Điều gì sẽ xảy ra khi tôi hủy đăng ký?",
  "pricing-faq-question-7-answer-1": "Khi hủy đăng ký, thanh toán tự động sẽ dừng từ ngày thanh toán tiếp theo.",
  "pricing-faq-question-7-answer-2": "Trong trường hợp vẫn còn thời gian sử dụng đối với gói đăng ký đã thanh toán, bạn có thể tiếp tục sử dụng gói hiện tại cho đến hết thời hạn đăng ký.",
  "pricing-faq-question-7-answer-3": "Khi thời hạn đăng ký kết thúc, bạn sẽ không thể sử dụng các credit đã nạp. Bạn có thể sử dụng lại các credit này khi đăng ký lại gói dịch vụ.",
  "pricing-faq-question-8": "Tôi có thể được hoàn tiền không?",
  "pricing-faq-question-8-answer-1": "Về nguyên tắc, số tiền thanh toán cho gói đăng ký và credit đã nạp sẽ không được hoàn lại.",
  "pricing-faq-question-8-answer-2": "Tuy nhiên, việc hoàn tiền có thể được xem xét trong các trường hợp đặc biệt do lỗi của công ty hoặc theo yêu cầu của luật pháp hiện hành.",
  "pricing-faq-question-8-answer-3": "Vui lòng tham khảo {link} để biết thêm chi tiết.",
  "pricing-faq-question-9": "Số tiền hoàn lại được tính dựa trên tiêu chí nào và tôi có thể yêu cầu hoàn tiền bằng cách nào?",
  "pricing-faq-question-9-answer-1": "Trong trường hợp đặc biệt được chấp thuận hoàn tiền, số tiền hoàn lại sẽ được tính dựa trên số tiền thanh toán thực tế (bao gồm cả thuế).",
  "pricing-faq-question-9-answer-2": "Số tiền thanh toán thông qua mã giảm giá hoặc khuyến mãi sẽ không được hoàn lại.",
  "pricing-faq-question-9-answer-3": "Nếu cần xem xét hoàn tiền, bạn có thể gửi yêu cầu qua biểu tượng Contact Us (Channel Talk) ở phía dưới màn hình hoặc gửi email tới {link1}.\nSau khi xem xét, chúng tôi sẽ thông báo về khả năng hoàn tiền và số tiền hoàn lại cuối cùng.",
  "pricing-info-1-title": "Gói đăng ký chỉ dành cho tài khoản tổ chức",
  "pricing-info-2-title": "Bạn phải tạo một tổ chức trước khi sử dụng gói đăng ký",
  "pricing-info-2-description": "Đi đến Cài đặt tổ chức",
  "pricing-info-3-title": "Chỉ Quản trị viên chính của tổ chức mới có thể tiến hành thanh toán gói đăng ký",
  "payment-payment-information": "Thông tin thanh toán",
  "payment-organization-information": "Thông tin tổ chức",
  "payment-payment-method": "Phương thức thanh toán",
  "payment-cardholder-name": "Tên chủ thẻ",
  "payment-card-number": "Số thẻ",
  "payment-expiration-date": "Ngày hết hạn",
  "payment-security-code": "Mã bảo mật",
  "payment-product-price": "Giá sản phẩm",
  "payment-coupon-discount": "Mã giảm giá",
  "payment-select-coupon": "Chọn mã giảm giá",
  "payment-coupon-discount-amount": "Số tiền giảm từ mã giảm giá",
  "payment-cancel-coupon": "Hủy áp dụng mã giảm giá",
  "payment-estimated-payment-amount": "Số tiền thanh toán dự kiến",
  "payment-tax-description": "Thuế sẽ được tính khi thanh toán.",
  "payment-agree-all-check": "Tôi đồng ý với tất cả.",
  "payment-agree-required": "Bắt buộc",
  "payment-agree-check-1": "Tôi đồng ý với {policy} và {term}.",
  "payment-agree-check-2": "Tôi đồng ý tự động gia hạn đăng ký và lưu phương thức thanh toán.",
  "payment-subscribe": "Đăng ký",
  "payment-subscribe-processing": "Đang xử lý",
  "payment-subscribe-info-1": "Tự động thanh toán theo chu kỳ thanh toán của bạn.",
  "payment-subscribe-info-2": "Nếu ngày thanh toán rơi vào một ngày không có trong tháng đó (ví dụ: ngày 31), thanh toán sẽ được xử lý vào ngày cuối cùng của tháng.",
  "payment-cardholder-name-error-1": "Vui lòng nhập tên chủ thẻ.",
  "payment-cardholder-name-error-2": "Tên chủ thẻ phải chứa từ 1 đến 20 ký tự.",
  "payment-card-number-error-1": "Vui lòng nhập số thẻ.",
  "payment-card-number-error-2": "Vui lòng kiểm tra lại số thẻ.",
  "payment-expiration-date-error-1": "Vui lòng nhập ngày hết hạn.",
  "payment-expiration-date-error-2": "Vui lòng kiểm tra lại ngày hết hạn.",
  "payment-security-code-error-1": "Vui lòng nhập mã bảo mật.",
  "payment-security-code-error-2": "Vui lòng kiểm tra lại mã bảo mật.",
  "payment-coupon": "Mã giảm giá",
  "payment-my-coupons": "Mã giảm giá của tôi",
  "payment-annual-billing-only": "Chỉ áp dụng cho thanh toán hàng năm",
  "payment-monthly-subscription-only": "Chỉ áp dụng cho thanh toán hàng tháng",
  "payment-first-purchase-only": "Chỉ áp dụng cho lần thanh toán đầu tiên",
  "payment-benefits": "Quyền lợi",
  "payment-validity-period": "Thời hạn hiệu lực",
  "payment-days-left": "Còn 00 ngày",
  "payment-coupon-applied-success": "Mã giảm giá đã được áp dụng.",
  "payment-coupon-applied-fail": "Chúng tôi không thể áp dụng mã giảm giá.\nVui lòng thử lại.",
  "payment-register-coupon": "Đăng ký mã giảm giá",
  "payment-coupon-code": "Mã giảm giá",
  "payment-coupon-code-placeholder": "Vui lòng nhập mã giảm giá.",
  "payment-coupon-code-error": "Mã giảm giá không hợp lệ.",
  "payment-coupon-code-success": "Mã giảm giá đã được đăng ký.",
  "payment-coupon-code-fail": "Chúng tôi không thể đăng ký mã giảm giá.\nVui lòng thử lại.",
  "payment-agree-required-error": "Vui lòng đồng ý với các mục bắt buộc.",
  "payment-error-title": "Thanh toán không thành công",
  "payment-error-contents": "Vui lòng kiểm tra thông tin thẻ đã nhập và thử lại.\nNếu thanh toán vẫn không thành công, vui lòng sử dụng thẻ khác hoặc liên hệ với ngân hàng phát hành thẻ.\nNếu vấn đề vẫn tiếp diễn, vui lòng liên hệ với chúng tôi qua mục {contact}.",
  "payment-error-contents-2": "Vui lòng thử lại.\nNếu thanh toán vẫn không thành công, vui lòng sử dụng thẻ khác hoặc liên hệ với ngân hàng phát hành thẻ.\nNếu vấn đề vẫn tiếp diễn, vui lòng liên hệ với chúng tôi qua mục {contact}.",
  "payment-payment-method-none": "Chưa có phương thức thanh toán nào được đăng ký.",
  "payment-payment-method-register": "Đăng ký phương thức thanh toán",
  "payment-payment-method-register-success": "Đăng ký phương thức thanh toán đã hoàn tất.",
  "payment-payment-method-register-fail-title": "Đăng ký phương thức thanh toán không thành công",
  "payment-payment-method-register-fail-contents": "Vui lòng kiểm tra thông tin thẻ và thử lại.\nNếu thanh toán vẫn không thành công, vui lòng sử dụng thẻ khác hoặc liên hệ với ngân hàng phát hành thẻ.\nNếu vấn đề vẫn tiếp diễn, vui lòng liên hệ với chúng tôi qua mục {contact}.",
  "payment-payment-method-change-fail-title": "Thay đổi phương thức thanh toán không thành công",
  "payment-complete-title": "Thanh toán hoàn tất",
  "payment-complete-payment-history": "Lịch sử Thanh toán",
  "payment-complete-payment-date": "Ngày thanh toán",
  "payment-complete-payment-amount": "Số tiền thanh toán",
  "payment-complete-view-invoice": "Xem Hóa đơn",
  "payment-complete-next-billing-date": "Ngày thanh toán tiếp theo",
  "payment-complete-description": "Xem {payment} để biết thêm thông tin chi tiết.",
  "payment-complete-button": "Đi đến Quản lý đăng ký",
  "learning-away-with-out-title": "Bạn có muốn thoát ra mà không nộp câu trả lời không?",
  "learning-away-with-out-description": "Bạn nên nộp câu trả lời để câu trả lời được lưu lại trước khi thoát ra.\nNếu bạn có bất kỳ thay đổi bổ sung nào sau khi nộp, bạn vẫn có thể nộp lại.",
  "learning-away-with-out-leave": "Thoát và không nộp",
  "learning-away-with-out-stay": "Ở lại",
  "skillCertify-locale-change-away-with-out-title": "Bạn có muốn thay đổi ngôn ngữ mà không lưu câu trả lời không?",
  "skillCertify-locale-change-away-with-out-description": "Bạn nên nộp câu trả lời để câu trả lời được lưu lại trước khi thay đổi ngôn ngữ.\nNếu bạn có bất kỳ thay đổi bổ sung nào sau khi nộp, bạn vẫn có thể nộp lại.",
  "skillCertify-locale-change-away-with-out": "Thay đổi ngôn ngữ mà không lưu",
  "terms-agree-title": "",
  "terms-agree-check-1": "",
  "terms-agree-check-2": "",
  "terms-agree-check-3": "",
  "skillCertify-not-participated": "",
  "skillCertify-no-show": "",
  "skillCertify-candidate-no-show-date": "",
  "skillCertify-proctoring-program-currently-running-title": "",
  "skillCertify-proctoring-program-currently-running-description": "",
  "skillCertify-close-proctoring-program-title": "",
  "skillCertify-close-proctoring-program-description": "",
  "skillCertify-close-proctoring-program-button": "",
  "skillCertify-proctoring-face-voice-recording-set-up-camera-no-use": "",
  "skillCertify-proctoring-face-voice-recording-set-up-camera-check-required": "",
  "skillCertify-proctoring-face-voice-recording-set-up-microphone-check-required": "",
  "skillCertify-assessment-completed-close-proctoring-program": "",
  "skillMonitor-track-summary-table-all-average-score": "",
  "skillMonitor-all-candidates-based-info": "",
  "skillMonitor-all-candidates-based-info-median": "",
  "skillMonitor-track-summary-table-all-average-skill-rate": "",
  "skillMonitor-candidate-sw-quality-analysis-info": "",
  "skillMonitor-candidate-code-quality-summary-result": "",
  "skillMonitor-candidate-code-quality-grade": "",
  "skillMonitor-candidate-code-quality-details": "",
  "skillMonitor-candidate-code-button": "",
  "skillMonitor-static-analysis-metrics": "",
  "skillMonitor-static-analysis": "",
  "skillMonitor-analysis-severity-medium": "",
  "skillMonitor-candidate-architecture-quality-summary-result": "",
  "skillMonitor-candidate-architecture-quality-grade": "",
  "skillMonitor-candidate-architecture-quality-details": "",
  "user-grades-type-chief-admin": "",
  "home-faq-helpcenter": "",
  "home-faq-hero-title": "",
  "home-faq-search-placeholder": "",
  "home-faq-search-result-count": "",
  "home-faq-help-count": "",
  "home-faq-admin-category-credit": "",
  "home-faq-admin-category-candidate-manage": "",
  "home-faq-admin-category-report": "",
  "home-faq-admin-category-skillfit-ops": "",
  "home-faq-admin-category-org-role": "",
  "home-faq-admin-category-security": "",
  "home-faq-tab-user": "",
  "home-faq-user-category-invite-start": "",
  "home-faq-user-category-check": "",
  "home-faq-user-category-proctor": "",
  "home-faq-user-category-result": "",
  "home-faq-user-category-skillfit": "",
  "home-faq-user-category-troubleshoot": "",
  "home-faq-bottom-title": "",
  "home-faq-bottom-description": "",
  "home-faq-admin-getting-started-question-1": "",
  "home-faq-admin-getting-started-question-1-answer-1": "",
  "home-faq-admin-getting-started-question-1-answer-2": "",
  "home-faq-admin-getting-started-question-1-answer-3": "",
  "home-faq-admin-getting-started-question-1-answer-4": "",
  "home-faq-admin-getting-started-question-1-answer-5": "",
  "home-faq-admin-getting-started-question-2": "",
  "home-faq-admin-getting-started-question-2-answer-1": "",
  "home-faq-admin-getting-started-question-2-answer-2": "",
  "home-faq-admin-getting-started-question-3": "",
  "home-faq-admin-getting-started-question-3-answer-1": "",
  "home-faq-admin-getting-started-question-3-answer-2": "",
  "home-faq-admin-getting-started-question-3-answer-3": "",
  "home-faq-admin-getting-started-question-4": "",
  "home-faq-admin-getting-started-question-4-answer-1": "",
  "home-faq-admin-getting-started-question-4-answer-2": "",
  "home-faq-admin-getting-started-question-5": "",
  "home-faq-admin-getting-started-question-5-answer-1": "",
  "home-faq-admin-getting-started-question-5-answer-2": "",
  "home-faq-admin-getting-started-question-5-answer-3": "",
  "home-faq-admin-getting-started-question-5-answer-4": "",
  "home-faq-admin-getting-started-question-5-answer-5": "",
  "home-faq-admin-getting-started-question-5-answer-6": "",
  "home-faq-admin-getting-started-question-5-answer-7": "",
  "home-faq-admin-credit-question-1": "",
  "home-faq-admin-credit-question-1-answer-1": "",
  "home-faq-admin-credit-question-1-answer-2": "",
  "home-faq-admin-credit-question-1-answer-3": "",
  "home-faq-admin-credit-question-1-answer-4": "",
  "home-faq-admin-credit-question-2": "",
  "home-faq-admin-credit-question-2-answer-1": "",
  "home-faq-admin-credit-question-2-answer-2": "",
  "home-faq-admin-credit-question-2-answer-3": "",
  "home-faq-admin-org-role-question-1": "",
  "home-faq-admin-org-role-question-1-answer-1": "",
  "home-faq-admin-org-role-question-1-answer-2": "",
  "home-faq-admin-org-role-question-1-answer-3": "",
  "home-faq-admin-org-role-question-1-answer-4": "",
  "home-faq-admin-org-role-question-1-answer-5": "",
  "home-faq-admin-org-role-question-1-answer-6": "",
  "home-faq-admin-org-role-question-1-answer-7": "",
  "home-faq-admin-org-role-question-1-answer-8": "",
  "home-faq-admin-org-role-question-1-answer-9": "",
  "home-faq-admin-org-role-question-1-answer-10": "",
  "home-faq-admin-org-role-question-1-answer-11": "",
  "home-faq-admin-org-role-question-2": "",
  "home-faq-admin-org-role-question-2-answer-1": "",
  "home-faq-admin-org-role-question-2-answer-2": "",
  "home-faq-admin-org-role-question-2-answer-3": "",
  "home-faq-admin-org-role-question-2-answer-4": "",
  "home-faq-admin-org-role-question-2-answer-5": "",
  "home-faq-admin-org-role-question-2-answer-6": "",
  "home-faq-admin-org-role-question-2-answer-7": "",
  "home-faq-admin-org-role-question-3": "",
  "home-faq-admin-org-role-question-3-answer-1": "",
  "home-faq-admin-org-role-question-3-answer-2": "",
  "home-faq-admin-org-role-question-4": "",
  "home-faq-admin-org-role-question-4-answer-1": "",
  "home-faq-admin-org-role-question-4-answer-2": "",
  "home-faq-admin-org-role-question-5": "",
  "home-faq-admin-org-role-question-5-answer-1": "",
  "home-faq-admin-org-role-question-5-answer-2": "",
  "home-faq-admin-org-role-question-5-answer-3": "",
  "home-faq-admin-org-role-question-5-answer-4": "",
  "home-faq-admin-org-role-question-6": "",
  "home-faq-admin-org-role-question-6-answer-1": "",
  "home-faq-admin-org-role-question-6-answer-2": "",
  "home-faq-admin-org-role-question-6-answer-3": "",
  "home-faq-admin-org-role-question-6-answer-4": "",
  "home-faq-admin-org-role-question-7": "",
  "home-faq-admin-org-role-question-7-answer-1": "",
  "home-faq-admin-org-role-question-7-answer-2": "",
  "home-faq-admin-assessment-create-question-1": "",
  "home-faq-admin-assessment-create-question-1-answer-1": "",
  "home-faq-admin-assessment-create-question-1-answer-2": "",
  "home-faq-admin-assessment-create-question-1-answer-3": "",
  "home-faq-admin-assessment-create-question-1-answer-4": "",
  "home-faq-admin-assessment-create-question-1-answer-5": "",
  "home-faq-admin-assessment-create-question-1-answer-6": "",
  "home-faq-admin-assessment-create-question-1-answer-7": "",
  "home-faq-admin-assessment-create-question-1-answer-8": "",
  "home-faq-admin-assessment-create-question-1-answer-9": "",
  "home-faq-admin-assessment-create-question-1-answer-10": "",
  "home-faq-admin-assessment-create-question-1-answer-11": "",
  "home-faq-admin-assessment-create-question-1-answer-12": "",
  "home-faq-admin-assessment-create-question-1-answer-13": "",
  "home-faq-admin-assessment-create-question-1-answer-14": "",
  "home-faq-admin-assessment-create-question-2": "",
  "home-faq-admin-assessment-create-question-2-answer-1": "",
  "home-faq-admin-assessment-create-question-2-answer-2": "",
  "home-faq-admin-assessment-create-question-2-answer-3": "",
  "home-faq-admin-assessment-create-question-2-answer-4": "",
  "home-faq-admin-assessment-create-question-2-answer-5": "",
  "home-faq-admin-assessment-create-question-3": "",
  "home-faq-admin-assessment-create-question-3-answer-1": "",
  "home-faq-admin-assessment-create-question-3-answer-2": "",
  "home-faq-admin-assessment-create-question-4": "",
  "home-faq-admin-assessment-create-question-4-answer-1": "",
  "home-faq-admin-assessment-create-question-4-answer-2": "",
  "home-faq-admin-assessment-create-question-4-answer-3": "",
  "home-faq-admin-assessment-create-question-4-answer-4": "",
  "home-faq-admin-assessment-create-question-4-answer-5": "",
  "home-faq-admin-assessment-create-question-4-answer-6": "",
  "home-faq-admin-assessment-create-question-4-answer-7": "",
  "home-faq-admin-assessment-create-question-4-answer-8": "",
  "home-faq-admin-assessment-create-question-5": "",
  "home-faq-admin-assessment-create-question-5-answer-1": "",
  "home-faq-admin-assessment-create-question-5-answer-2": "",
  "home-faq-admin-assessment-create-question-5-answer-3": "",
  "home-faq-admin-assessment-create-question-5-answer-4": "",
  "home-faq-admin-assessment-create-question-5-answer-5": "",
  "home-faq-admin-assessment-create-question-5-answer-6": "",
  "home-faq-admin-assessment-create-question-5-answer-7": "",
  "home-faq-admin-assessment-create-question-6": "",
  "home-faq-admin-assessment-create-question-6-answer-1": "",
  "home-faq-admin-assessment-create-question-6-answer-2": "",
  "home-faq-admin-assessment-create-question-6-answer-3": "",
  "home-faq-admin-assessment-create-question-6-answer-4": "",
  "home-faq-admin-assessment-create-question-6-answer-5": "",
  "home-faq-admin-assessment-create-question-6-answer-6": "",
  "home-faq-admin-assessment-create-question-6-answer-7": "",
  "home-faq-admin-assessment-create-question-6-answer-8": "",
  "home-faq-admin-assessment-create-question-6-answer-9": "",
  "home-faq-admin-assessment-create-question-6-answer-10": "",
  "home-faq-admin-assessment-create-question-7": "",
  "home-faq-admin-assessment-create-question-7-answer-1": "",
  "home-faq-admin-assessment-create-question-7-answer-2": "",
  "home-faq-admin-assessment-create-question-7-answer-3": "",
  "home-faq-admin-assessment-create-question-7-answer-4": "",
  "home-faq-admin-assessment-create-question-8": "",
  "home-faq-admin-assessment-create-question-8-answer-1": "",
  "home-faq-admin-assessment-create-question-8-answer-2": "",
  "home-faq-admin-assessment-create-question-8-answer-3": "",
  "home-faq-admin-assessment-create-question-8-answer-4": "",
  "home-faq-admin-assessment-create-question-9": "",
  "home-faq-admin-assessment-create-question-9-answer-1": "",
  "home-faq-admin-assessment-create-question-9-answer-2": "",
  "home-faq-admin-assessment-create-question-9-answer-3": "",
  "home-faq-admin-assessment-create-question-9-answer-4": "",
  "home-faq-admin-assessment-create-question-9-answer-5": "",
  "home-faq-admin-assessment-create-question-9-answer-6": "",
  "home-faq-admin-assessment-create-question-9-answer-7": "",
  "home-faq-admin-assessment-create-question-9-answer-8": "",
  "home-faq-admin-assessment-create-question-9-answer-9": "",
  "home-faq-admin-assessment-create-question-9-answer-10": "",
  "home-faq-admin-assessment-create-question-9-answer-11": "",
  "home-faq-admin-assessment-create-question-9-answer-12": "",
  "home-faq-admin-assessment-create-question-9-answer-13": "",
  "home-faq-admin-assessment-create-question-10": "",
  "home-faq-admin-assessment-create-question-10-answer-1": "",
  "home-faq-admin-assessment-create-question-10-answer-2": "",
  "home-faq-admin-candidate-manage-question-1": "",
  "home-faq-admin-candidate-manage-question-1-answer-1": "",
  "home-faq-admin-candidate-manage-question-1-answer-2": "",
  "home-faq-admin-candidate-manage-question-1-answer-3": "",
  "home-faq-admin-candidate-manage-question-1-answer-4": "",
  "home-faq-admin-candidate-manage-question-1-answer-5": "",
  "home-faq-admin-candidate-manage-question-1-answer-6": "",
  "home-faq-admin-candidate-manage-question-1-answer-7": "",
  "home-faq-admin-candidate-manage-question-1-answer-8": "",
  "home-faq-admin-candidate-manage-question-1-answer-9": "",
  "home-faq-admin-candidate-manage-question-2": "",
  "home-faq-admin-candidate-manage-question-2-answer-1": "",
  "home-faq-admin-candidate-manage-question-2-answer-2": "",
  "home-faq-admin-candidate-manage-question-2-answer-3": "",
  "home-faq-admin-candidate-manage-question-2-answer-4": "",
  "home-faq-admin-candidate-manage-question-3": "",
  "home-faq-admin-candidate-manage-question-3-answer-1": "",
  "home-faq-admin-candidate-manage-question-3-answer-2": "",
  "home-faq-admin-candidate-manage-question-3-answer-3": "",
  "home-faq-admin-candidate-manage-question-3-answer-4": "",
  "home-faq-admin-candidate-manage-question-3-answer-5": "",
  "home-faq-admin-candidate-manage-question-3-answer-6": "",
  "home-faq-admin-candidate-manage-question-3-answer-7": "",
  "home-faq-admin-candidate-manage-question-3-answer-8": "",
  "home-faq-admin-candidate-manage-question-4": "",
  "home-faq-admin-candidate-manage-question-4-answer-1": "",
  "home-faq-admin-candidate-manage-question-4-answer-2": "",
  "home-faq-admin-candidate-manage-question-4-answer-3": "",
  "home-faq-admin-candidate-manage-question-4-answer-4": "",
  "home-faq-admin-candidate-manage-question-5": "",
  "home-faq-admin-candidate-manage-question-5-answer-1": "",
  "home-faq-admin-candidate-manage-question-5-answer-2": "",
  "home-faq-admin-candidate-manage-question-5-answer-3": "",
  "home-faq-admin-candidate-manage-question-5-answer-4": "",
  "home-faq-admin-candidate-manage-question-6": "",
  "home-faq-admin-candidate-manage-question-6-answer-1": "",
  "home-faq-admin-candidate-manage-question-6-answer-2": "",
  "home-faq-admin-candidate-manage-question-6-answer-3": "",
  "home-faq-admin-report-question-1": "",
  "home-faq-admin-report-question-1-answer-1": "",
  "home-faq-admin-report-question-1-answer-2": "",
  "home-faq-admin-report-question-1-answer-3": "",
  "home-faq-admin-report-question-1-answer-4": "",
  "home-faq-admin-report-question-2": "",
  "home-faq-admin-report-question-2-answer-1": "",
  "home-faq-admin-report-question-2-answer-2": "",
  "home-faq-admin-report-question-2-answer-3": "",
  "home-faq-admin-report-question-2-answer-4": "",
  "home-faq-admin-report-question-2-answer-5": "",
  "home-faq-admin-report-question-2-answer-6": "",
  "home-faq-admin-report-question-2-answer-7": "",
  "home-faq-admin-report-question-2-answer-8": "",
  "home-faq-admin-report-question-2-answer-9": "",
  "home-faq-admin-report-question-2-answer-10": "",
  "home-faq-admin-report-question-3": "",
  "home-faq-admin-report-question-3-answer-1": "",
  "home-faq-admin-report-question-3-answer-2": "",
  "home-faq-admin-report-question-4": "",
  "home-faq-admin-report-question-4-answer-1": "",
  "home-faq-admin-report-question-4-answer-2": "",
  "home-faq-admin-report-question-5": "",
  "home-faq-admin-report-question-5-answer-1": "",
  "home-faq-admin-report-question-6": "",
  "home-faq-admin-report-question-6-answer-1": "",
  "home-faq-admin-report-question-6-answer-2": "",
  "home-faq-admin-skillfit-ops-question-1": "",
  "home-faq-admin-skillfit-ops-question-1-answer-1": "",
  "home-faq-admin-skillfit-ops-question-1-answer-2": "",
  "home-faq-admin-skillfit-ops-question-2": "",
  "home-faq-admin-skillfit-ops-question-2-answer-1": "",
  "home-faq-admin-skillfit-ops-question-2-answer-2": "",
  "home-faq-admin-skillfit-ops-question-2-answer-3": "",
  "home-faq-admin-skillfit-ops-question-2-answer-4": "",
  "home-faq-admin-skillfit-ops-question-2-answer-5": "",
  "home-faq-admin-security-question-1": "",
  "home-faq-admin-security-question-1-answer-1": "",
  "home-faq-admin-security-question-1-answer-2": "",
  "home-faq-admin-security-question-2": "",
  "home-faq-admin-security-question-2-answer-1": "",
  "home-faq-admin-security-question-2-answer-2": "",
  "home-faq-user-invite-start-question-1": "",
  "home-faq-user-invite-start-question-1-answer-1": "",
  "home-faq-user-invite-start-question-1-answer-2": "",
  "home-faq-user-invite-start-question-1-answer-3": "",
  "home-faq-user-invite-start-question-1-answer-4": "",
  "home-faq-user-invite-start-question-1-answer-5": "",
  "home-faq-user-invite-start-question-1-answer-6": "",
  "home-faq-user-invite-start-question-1-answer-7": "",
  "home-faq-user-invite-start-question-1-answer-8": "",
  "home-faq-user-invite-start-question-1-answer-9": "",
  "home-faq-user-invite-start-question-2-answer-1": "",
  "home-faq-user-invite-start-question-2-answer-2": "",
  "home-faq-user-invite-start-question-2-answer-3": "",
  "home-faq-user-invite-start-question-2-answer-4": "",
  "home-faq-user-invite-start-question-2-answer-5": "",
  "home-faq-user-invite-start-question-3-answer-1": "",
  "home-faq-user-invite-start-question-3-answer-2": "",
  "home-faq-user-invite-start-question-3-answer-3": "",
  "home-faq-user-invite-start-question-4": "",
  "home-faq-user-invite-start-question-4-answer-1": "",
  "home-faq-user-invite-start-question-4-answer-2": "",
  "home-faq-user-invite-start-question-4-answer-3": "",
  "home-faq-user-invite-start-question-4-answer-4": "",
  "home-faq-user-invite-start-question-5": "",
  "home-faq-user-invite-start-question-5-answer-1": "",
  "home-faq-user-invite-start-question-5-answer-2": "",
  "home-faq-user-invite-start-question-5-answer-3": "",
  "home-faq-user-invite-start-question-5-answer-4": "",
  "home-faq-user-invite-start-question-6": "",
  "home-faq-user-invite-start-question-6-answer-1": "",
  "home-faq-user-invite-start-question-6-answer-2": "",
  "home-faq-user-invite-start-question-6-answer-3": "",
  "home-faq-user-invite-start-question-6-answer-4": "",
  "home-faq-user-check-question-1": "",
  "home-faq-user-check-question-1-answer-1": "",
  "home-faq-user-check-question-1-answer-2": "",
  "home-faq-user-check-question-1-answer-3": "",
  "home-faq-user-check-question-2": "",
  "home-faq-user-check-question-2-answer-1": "",
  "home-faq-user-check-question-2-answer-2": "",
  "home-faq-user-check-question-2-answer-3": "",
  "home-faq-user-check-question-2-answer-4": "",
  "home-faq-user-check-question-2-answer-5": "",
  "home-faq-user-check-question-2-answer-6": "",
  "home-faq-user-check-question-3": "",
  "home-faq-user-check-question-3-answer-1": "",
  "home-faq-user-check-question-3-answer-2": "",
  "home-faq-user-check-question-4": "",
  "home-faq-user-check-question-4-answer-1": "",
  "home-faq-user-check-question-4-answer-2": "",
  "home-faq-user-check-question-5": "",
  "home-faq-user-check-question-5-answer-1": "",
  "home-faq-user-check-question-5-answer-2": "",
  "home-faq-user-assessment-take-question-1": "",
  "home-faq-user-assessment-take-question-1-answer-1": "",
  "home-faq-user-assessment-take-question-1-answer-2": "",
  "home-faq-user-assessment-take-question-1-answer-3": "",
  "home-faq-user-assessment-take-question-1-answer-4": "",
  "home-faq-user-assessment-take-question-1-answer-5": "",
  "home-faq-user-assessment-take-question-2": "",
  "home-faq-user-assessment-take-question-2-answer-1": "",
  "home-faq-user-assessment-take-question-2-answer-2": "",
  "home-faq-user-assessment-take-question-2-answer-3": "",
  "home-faq-user-assessment-take-question-3": "",
  "home-faq-user-assessment-take-question-3-answer-1": "",
  "home-faq-user-assessment-take-question-3-answer-2": "",
  "home-faq-user-assessment-take-question-3-answer-3": "",
  "home-faq-user-assessment-take-question-3-answer-4": "",
  "home-faq-user-assessment-take-question-3-answer-5": "",
  "home-faq-user-assessment-take-question-4": "",
  "home-faq-user-assessment-take-question-4-answer-1": "",
  "home-faq-user-assessment-take-question-4-answer-2": "",
  "home-faq-user-assessment-take-question-4-answer-3": "",
  "home-faq-user-assessment-take-question-4-answer-4": "",
  "home-faq-user-assessment-take-question-5": "",
  "home-faq-user-assessment-take-question-5-answer-1": "",
  "home-faq-user-assessment-take-question-5-answer-2": "",
  "home-faq-user-assessment-take-question-6": "",
  "home-faq-user-assessment-take-question-6-answer-1": "",
  "home-faq-user-assessment-take-question-6-answer-2": "",
  "home-faq-user-assessment-take-question-6-answer-3": "",
  "home-faq-user-assessment-take-question-7": "",
  "home-faq-user-assessment-take-question-7-answer-1": "",
  "home-faq-user-assessment-take-question-7-answer-2": "",
  "home-faq-user-assessment-take-question-8": "",
  "home-faq-user-assessment-take-question-8-answer-1": "",
  "home-faq-user-assessment-take-question-8-answer-2": "",
  "home-faq-user-assessment-take-question-9": "",
  "home-faq-user-assessment-take-question-9-answer-1": "",
  "home-faq-user-assessment-take-question-9-answer-2": "",
  "home-faq-user-assessment-take-question-10": "",
  "home-faq-user-assessment-take-question-10-answer-1": "",
  "home-faq-user-assessment-take-question-10-answer-2": "",
  "home-faq-user-proctor-question-1": "",
  "home-faq-user-proctor-question-1-answer-1": "",
  "home-faq-user-proctor-question-1-answer-2": "",
  "home-faq-user-proctor-question-1-answer-3": "",
  "home-faq-user-proctor-question-1-answer-4": "",
  "home-faq-user-proctor-question-2": "",
  "home-faq-user-proctor-question-2-answer-1": "",
  "home-faq-user-proctor-question-2-answer-2": "",
  "home-faq-user-proctor-question-2-answer-3": "",
  "home-faq-user-proctor-question-2-answer-4": "",
  "home-faq-user-proctor-question-2-answer-5": "",
  "home-faq-user-proctor-question-2-answer-6": "",
  "home-faq-user-proctor-question-3": "",
  "home-faq-user-proctor-question-3-answer-1": "",
  "home-faq-user-proctor-question-3-answer-2": "",
  "home-faq-user-proctor-question-3-answer-3": "",
  "home-faq-user-proctor-question-3-answer-4": "",
  "home-faq-user-proctor-question-3-answer-5": "",
  "home-faq-user-proctor-question-4": "",
  "home-faq-user-proctor-question-4-answer-1": "",
  "home-faq-user-proctor-question-4-answer-2": "",
  "home-faq-user-proctor-question-5": "",
  "home-faq-user-proctor-question-5-answer-1": "",
  "home-faq-user-proctor-question-5-answer-2": "",
  "home-faq-user-result-question-1": "",
  "home-faq-user-result-question-1-answer-1": "",
  "home-faq-user-result-question-1-answer-2": "",
  "home-faq-user-result-question-1-answer-3": "",
  "home-faq-user-result-question-1-answer-4": "",
  "home-faq-user-result-question-1-answer-5": "",
  "home-faq-user-result-question-2": "",
  "home-faq-user-result-question-2-answer-1": "",
  "home-faq-user-result-question-3": "",
  "home-faq-user-result-question-3-answer-1": "",
  "home-faq-user-skillfit-question-1-answer-1": "",
  "home-faq-user-skillfit-question-1-answer-2": "",
  "home-faq-user-skillfit-question-1-answer-3": "",
  "home-faq-user-skillfit-question-2": "",
  "home-faq-user-skillfit-question-2-answer-1": "",
  "home-faq-user-skillfit-question-2-answer-2": "",
  "home-faq-user-skillfit-question-2-answer-3": "",
  "home-faq-user-skillfit-question-2-answer-4": "",
  "home-faq-user-skillfit-question-3": "",
  "home-faq-user-skillfit-question-3-answer-1": "",
  "home-faq-user-skillfit-question-3-answer-2": "",
  "home-faq-user-skillfit-question-3-answer-3": "",
  "home-faq-user-troubleshoot-question-1": "",
  "home-faq-user-troubleshoot-question-1-answer-1": "",
  "home-faq-user-troubleshoot-question-1-answer-2": "",
  "home-faq-user-troubleshoot-question-1-answer-3": "",
  "home-faq-user-troubleshoot-question-2": "",
  "home-faq-user-troubleshoot-question-2-answer-1": "",
  "home-faq-user-troubleshoot-question-2-answer-2": "",
  "home-faq-user-troubleshoot-question-3": "",
  "home-faq-user-troubleshoot-question-3-answer-1": "",
  "home-faq-user-troubleshoot-question-3-answer-2": "",
  "home-faq-user-troubleshoot-question-3-answer-3": "",
  "home-faq-user-troubleshoot-question-3-answer-4": "",
  "home-faq-user-troubleshoot-question-4": "",
  "home-faq-user-troubleshoot-question-4-answer-1": "",
  "home-faq-user-troubleshoot-question-4-answer-2": "",
  "home-faq-user-troubleshoot-question-5": "",
  "home-faq-user-troubleshoot-question-5-answer-1": ""
};